import { FC } from "react";

/**
 * Thai content for the Sports Betting Rules modal.
 */
const RulesContentTH: FC = () => {
  return (
    <div className="text-sm leading-relaxed text-gray-800 space-y-2">
      <section>
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">กฎการเดิมพันกีฬา</h1>
        </div>

        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">A. ประเภทการเดิมพัน</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. 1X2</h3>
          <ol>
            <li className="flex pt-2">
              <div>1.1</div>
              <div className="pl-3">
                สามารถวางเดิมพันได้โดยเลือกทีมเหย้าชนะ เสมอ หรือทีมเยือนชนะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.2</div>
              <div className="pl-3">
                การเดิมพันจะตัดสินเมื่อจบการแข่งขันในเวลาปกติ ไม่รวมช่วงต่อเวลาพิเศษ
                และการยิงจุดโทษ (ในกรณีที่เกี่ยวข้อง)
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. อัตราต่อรองแบบเอเชียน (ASIAN HANDICAP)</h3>
          <ol>
            <li className="flex pt-2">
              <div>2.1</div>
              <div className="pl-3">
                อัตราต่อรองแบบเอเชียน (Asian Handicap) เป็นรูปแบบการเดิมพันที่เจ้ามือ
                กำหนดแต้มต่อให้แก่สองทีมในเกมก่อนที่การแข่งขันจะเริ่มต้น โดยใช้
                ฟุตบอลเป็นตัวอย่าง เจ้ามือจะกำหนดประตูต่อให้แก่ทีมที่คิดว่ามีโอกาส
                ชนะมากกว่า และให้แต้มต่อแก่ทีมที่คิดว่ามีโอกาสชนะน้อยกว่า แต้มต่อ
                จะแสดงเป็นจำนวนประตู หรือเศษส่วนของประตู เพื่อที่จะชนะการเดิมพัน
                ผู้ใช้ปลายทางไม่ได้เดิมพันให้ทีมชนะเพียงอย่างเดียว แต่เดิมพันให้ทีมนั้น
                เอาชนะแต้มต่อได้
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">3. ผลสกอร์ที่ถูกต้อง - ครึ่งแรก &amp; เต็มเวลา</h3>
          <ol>
            <li className="flex pt-2">
              <div>3.1</div>
              <div className="pl-3">สำหรับผลสกอร์ที่ถูกต้องครึ่งแรก:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันทำได้โดยการทายผลหรือสกอร์ที่ถูกต้องเมื่อจบครึ่งแรก
                ของการแข่งขันหรือเหตุการณ์ที่เปิดให้เดิมพัน
              </li>
              <li className="pt-2 pl-3">
                (B) กฎกีฬาทั่วไปข้อ 13 จะถูกนำมาใช้ในกรณีที่การแข่งขันหรือเหตุการณ์
                ถูกยกเลิก ระงับ หรือเลื่อนออกไปก่อนจบครึ่งแรก
              </li>
              <li className="pt-2 pl-3">
                (C) การเดิมพันจะตัดสินจากสกอร์ของการแข่งขันหรือเหตุการณ์เมื่อจบ
                ครึ่งแรก รวมถึงเวลาที่เพิ่มเข้ามาสำหรับการบาดเจ็บและการหยุดเกม
              </li>
            </ol>
            <li className="flex pt-2">
              <div>3.2</div>
              <div className="pl-3">สำหรับผลสกอร์ที่ถูกต้องเต็มเวลา:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันทำได้โดยการทายผลหรือสกอร์ที่ถูกต้องเมื่อจบการแข่งขัน
                หรือเหตุการณ์ที่เปิดให้เดิมพัน
              </li>
              <li className="pt-2 pl-3">
                (B) กฎกีฬาทั่วไปข้อ 13 จะถูกนำมาใช้ในกรณีที่การแข่งขันหรือเหตุการณ์
                ถูกยกเลิก ระงับ หรือเลื่อนออกไปก่อนจบการแข่งขันหรือเหตุการณ์
              </li>
              <li className="pt-2 pl-3">
                (C) การเดิมพันจะตัดสินจากสกอร์สุดท้ายของการแข่งขันหรือเหตุการณ์
                รวมถึงเวลาที่เพิ่มเข้ามาสำหรับการบาดเจ็บและการหยุดเกม
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. ดับเบิลแชนซ์</h3>
          <ol>
            <li className="flex pt-2">
              <div>4.1</div>
              <div className="pl-3">
                ดับเบิลแชนซ์มีลักษณะคล้ายกับการเดิมพัน 1X2 เพียงแต่ผู้ใช้ปลายทาง
                สามารถเดิมพันสองในสามผลลัพธ์ที่เป็นไปได้ โดยเลือกตัวเลือกต่อไปนี้:
                ทีมเหย้าชนะหรือทีมเยือนชนะ; เสมอหรือทีมเยือนชนะ; หรือเสมอหรือ
                ทีมเหย้าชนะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.2</div>
              <div className="pl-3">
                หากเกิดผลลัพธ์อย่างใดอย่างหนึ่งจากสองผลลัพธ์ที่เป็นไปได้ การเดิมพันจะชนะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.3</div>
              <div className="pl-3">
                หากการแข่งขันจัดขึ้นในสนามกลาง ทีมที่แสดงเป็นรายชื่อแรกบนเว็บไซต์
                จะถือเป็นทีมเหย้าเพื่อวัตถุประสงค์ในการเดิมพัน
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. ทีมที่เริ่มเล่นก่อน</h3>
          <div className="pt-2">
            ทายทีมหรือผู้เข้าแข่งขันที่เป็นฝ่ายเริ่มเกม/การแข่งขัน/เหตุการณ์
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. ครึ่งแรก/เต็มเวลา</h3>
          <div className="pt-2">
            เดิมพันผลครึ่งแรกและผลเต็มเวลาของการแข่งขันที่กำหนด
            (โปรดทราบว่าการเดิมพันจะเป็นโมฆะหากการแข่งขันเล่นในรูปแบบเวลา
            ที่ไม่ได้ระบุไว้อย่างชัดเจนในกฎการเดิมพันเฉพาะกีฬา)
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. มิกซ์ปาร์เลย์</h3>
          <div className="pt-2">
            การเดิมพันมิกซ์ปาร์เลย์คือการเดิมพันที่รวมการเลือกหลายรายการจากเกม
            หรือการแข่งขันที่แตกต่างกันที่เจ้ามือเปิดให้เดิมพัน ไม่อนุญาตให้เดิมพัน
            มิกซ์ปาร์เลย์ที่รวมการเลือกที่แตกต่างกันภายในเกมหรือการแข่งขันเดียวกัน
            ซึ่งผลลัพธ์ของรายการหนึ่งส่งผลต่ออีกรายการหนึ่ง
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">8. มันนี่ไลน์ / หัวต่อหัว</h3>
          <div className="pt-2">
            การเดิมพันมันนี่ไลน์ / หัวต่อหัว คือการเดิมพันผลลัพธ์ของการแข่งขันหรือ
            เหตุการณ์ระหว่างผู้เข้าแข่งขันสองฝ่ายที่จับคู่กัน ในกรณีที่ผลออกมาเสมอ
            การเดิมพันทั้งหมดจะคืนเงินเดิมพันที่อัตราต่อรอง 1.00
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. ประตูถัดไป</h3>
          <ol>
            <li className="flex pt-2">
              <div>9.1</div>
              <div className="pl-3">
                ทายทีมที่จะทำประตูถัดไปในการแข่งขันภายในเวลาเล่นปกติ
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                การทำเข้าประตูตัวเองจะนับให้เป็นประโยชน์แก่ทีมที่ได้รับเครดิตประตูนั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.3</div>
              <div className="pl-3">
                การเดิมพันจะคืนเงินเดิมพันหากการแข่งขันถูกยกเลิก เว้นแต่ผลได้ถูก
                ตัดสินอย่างไม่มีเงื่อนไขแล้ว
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">10. คู่/คี่</h3>
          <div className="pt-2">
            การเดิมพันจะตัดสินจากผลรวมทั้งหมดของแต้ม/ประตู (ซึ่งได้เป็นจำนวนคู่หรือ
            คี่) ในการแข่งขันหรือชุดของการแข่งขันที่วางเดิมพันไว้ สกอร์ 0-0 ถือเป็น
            จำนวนคู่
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">11. เอาท์ไรท์ (OUTRIGHT)</h3>
          <ol>
            <li className="flex pt-2">
              <div>11.1</div>
              <div className="pl-3">การเดิมพันเอาท์ไรท์เกี่ยวข้องกับการเลือก:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) ผู้ชนะในทัวร์นาเมนต์ การแข่งขัน ลีก การแข่ง หรือเหตุการณ์
                (“เหตุการณ์กีฬา”) (หรือส่วนใดส่วนหนึ่งหรือแง่มุมใดของเหตุการณ์นั้น);
                หรือ
              </li>
              <li className="pt-2 pl-3">
                (B) ทีมหรือผู้เข้าแข่งขันรายบุคคลที่จะได้อันดับในตำแหน่งที่เจาะจง
                หรือช่วงของตำแหน่งที่ผู้ให้บริการกำหนด ของเหตุการณ์กีฬา (หรือส่วนใด
                ส่วนหนึ่งหรือแง่มุมใดของเหตุการณ์นั้น); หรือ
              </li>
              <li className="pt-2 pl-3">
                (C) สองทีมหรือผู้เข้าแข่งขันรายบุคคลขึ้นไปที่จะได้อันดับในช่วงของ
                ตำแหน่งที่เจาะจงที่ผู้ให้บริการกำหนด ของเหตุการณ์กีฬา (หรือส่วนใด
                ส่วนหนึ่งหรือแง่มุมใดของเหตุการณ์นั้น); ไม่ว่าจะก่อนเริ่มหรือในระยะ
                ใดของเหตุการณ์กีฬา (หรือส่วนใดส่วนหนึ่งหรือแง่มุมใดของเหตุการณ์นั้น)
                ก่อนที่จะสิ้นสุด ซึ่งผลยังไม่ได้ตัดสิน
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.2</div>
              <div className="pl-3">
                ต่อไปนี้คือตัวอย่างบางส่วนของการเดิมพันเอาท์ไรท์ที่ผู้ให้บริการรับ:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) <u>ผลลัพธ์สุดท้าย</u>
              </li>
              <li className="pt-2 pl-3">
                (B) <u>ทีมที่ทำผลงานดีที่สุดในภูมิภาค</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) เดิมพันว่าทีมหรือผู้เข้าแข่งขันรายบุคคลจากภูมิภาคใดภูมิภาคหนึ่ง
                    จะไปได้ไกลที่สุดในเหตุการณ์กีฬา (หรือส่วนใดส่วนหนึ่งหรือแง่มุมใด
                    ของเหตุการณ์นั้น) (เช่น ทีมแอฟริกายอดเยี่ยม ทีมเอเชียยอดเยี่ยม
                    ทีมยุโรปยอดเยี่ยม ทีมอเมริกาเหนือและอเมริกากลางยอดเยี่ยม และ
                    ทีมอเมริกาใต้ยอดเยี่ยม ฯลฯ)
                  </li>
                  <li className="pt-2 pl-3">
                    (II) หากมีทีมหรือผู้เข้าแข่งขันรายบุคคลจากภูมิภาคเดียวกันมากกว่า
                    หนึ่งทีมตกรอบจากเหตุการณ์กีฬาในรอบที่ไกลที่สุดเดียวกัน หรือหาก
                    ทีมหรือผู้เข้าแข่งขันรายบุคคลจากภูมิภาคเดียวกันทั้งหมดถูกคัดออก
                    ในรอบแบ่งกลุ่มหรือรอบคัดเลือก กฎ Dead Heat จะถูกนำมาใช้
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) <u>ผู้ชนะกลุ่มหรือสายการแข่งขัน</u>
              </li>
              <li className="pt-2 pl-3">
                (D) <u>ผู้ทำประตูสูงสุด</u>
              </li>
              <li className="pt-2 pl-3">
                (E) <u>ตำแหน่งเจาะจงและผู้จบอันดับสูงสุดของกลุ่ม</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) ในตำแหน่งเจาะจงอื่นนอกเหนือจากผู้ชนะ (เช่น อันดับสอง
                    อันดับสาม ผู้เข้ารอบรองชนะเลิศ ฯลฯ); หรือ
                  </li>
                  <li className="pt-2 pl-3">
                    (II) ภายในช่วงตำแหน่งที่เลือก (เช่น Top 2, 5, 10 ฯลฯ) โดยไม่
                    คำนึงถึงตำแหน่งที่แน่นอนของทีมหรือผู้เข้าแข่งขันรายบุคคลใน
                    เหตุการณ์กีฬานั้น (หรือส่วนใดส่วนหนึ่งหรือแง่มุมใดของเหตุการณ์นั้น)
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (F) <u>การทายอันดับ</u>
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) การทายตรง - ภายในช่วงตำแหน่งที่เลือก (เช่น Top 2, 5, 10 ฯลฯ)
                    ตามลำดับตำแหน่งที่ถูกต้องเมื่อจบเหตุการณ์กีฬา (หรือส่วนใด
                    ส่วนหนึ่งหรือแง่มุมใดซึ่งรวมถึงแต่ไม่จำกัดเพียงรอบแบ่งกลุ่มหรือ
                    สายการแข่งขันของเหตุการณ์กีฬา); หรือ
                  </li>
                  <li className="pt-2 pl-3">
                    (II) การทายคู่ - ภายในช่วงตำแหน่งที่เลือก (เช่น Top 2, 5, 10 ฯลฯ)
                    โดยไม่คำนึงถึงตำแหน่งที่แน่นอนของทีมหรือผู้เข้าแข่งขันรายบุคคลใน
                    เหตุการณ์กีฬานั้น (หรือส่วนใดส่วนหนึ่งหรือแง่มุมใดซึ่งรวมถึงแต่ไม่
                    จำกัดเพียงรอบแบ่งกลุ่มหรือสายการแข่งขันของเหตุการณ์กีฬา)
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.3</div>
              <div className="pl-3">
                การเดิมพันเอาท์ไรท์อาจเปิดให้เดิมพันได้ทั้งก่อนเริ่มหรือในระยะใด
                ของเหตุการณ์กีฬาก่อนที่จะสิ้นสุด ซึ่งผลสำหรับประเภทการเดิมพันนั้น
                ยังไม่ได้ตัดสิน
              </div>
            </li>
            <li className="flex pt-2">
              <div>11.4</div>
              <div className="pl-3">
                ไม่มีการคืนเงินเดิมพันสำหรับผู้ที่ไม่ได้ลงแข่งในการเดิมพันเอาท์ไรท์
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) ผู้ที่ไม่ได้ลงแข่งหมายถึงทีมหรือผู้เข้าแข่งขันรายบุคคลหรือผู้เล่นที่
                ไม่ได้เริ่มเหตุการณ์กีฬา แม้ว่าจะมีชื่ออยู่ในรายชื่อสุดท้ายก็ตาม (เช่น
                ผู้ทำประตูสูงสุด)
              </li>
              <li className="pt-2 pl-3">
                (B) หากทีม ผู้เข้าแข่งขันรายบุคคล หรือผู้เล่นถอนตัว เลิกเล่น หรือถูก
                ตัดสิทธิ์ก่อนเริ่มเหตุการณ์กีฬา การเดิมพันบนทีม ผู้เข้าแข่งขันรายบุคคล
                หรือผู้เล่นนั้นจะคืนเงินเดิมพัน (เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎ
                การเดิมพันเฉพาะกีฬา)
              </li>
              <li className="pt-2 pl-3">
                (C) หากกรณีใด ๆ ที่กล่าวข้างต้นเกี่ยวข้องกับทีม ผู้เข้าแข่งขันรายบุคคล
                หรือผู้เล่นที่เป็นตัวเต็ง และส่งผลต่ออัตราต่อรองหรือการจ่ายเงินของการ
                เดิมพันเอาท์ไรท์สำหรับเหตุการณ์กีฬานั้นโดยรวม การเดิมพันเอาท์ไรท์
                ทั้งหมดบนเหตุการณ์กีฬานั้นจะคืนเงินเดิมพันตามนั้น
              </li>
            </ol>
            <li className="flex pt-2">
              <div>11.5</div>
              <div className="pl-3">
                กฎ Dead Heat ใช้กับการเดิมพันเอาท์ไรท์ทั้งหมด
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">12. สูง/ต่ำ</h3>
          <div className="pt-2">
            การเดิมพันจะตัดสินจากผลรวมทั้งหมดของแต้ม/ประตู ฯลฯ ที่ทำได้ (ซึ่งได้
            ผลสูงหรือต่ำกว่าจำนวนเป้าหมายที่ผู้ให้บริการกำหนด) ในการแข่งขันหรือชุด
            ของการแข่งขันที่วางเดิมพันไว้
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">13. การเดิมพันรายช่วง</h3>
          <ol>
            <li className="flex pt-2">
              <div>13.1</div>
              <div className="pl-3">
                การเดิมพันรายช่วงหมายถึงการวางเดิมพันบนช่วงต่าง ๆ ของเกม (เช่น
                ควอเตอร์ ครึ่ง พีเรียด เซต ยก หรือโอเวอร์)
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.2</div>
              <div className="pl-3">
                ในการเดิมพันรายช่วง ช่วงนั้นต้องเล่นจบเพื่อให้การเดิมพันมีผล
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.3</div>
              <div className="pl-3">
                ในการเดิมพันรายช่วง ช่วงต่อเวลาหรือเวลาพิเศษจะไม่ถูกนำมารวมในการ
                ตัดสินสกอร์ หากไม่ได้ระบุเป็นอย่างอื่น
              </div>
            </li>
            <li className="flex pt-2">
              <div>13.4</div>
              <div className="pl-3">
                ภายใต้กฎการเดิมพันเฉพาะกีฬา การเดิมพันรายช่วงในครึ่งหลังจะรวมช่วง
                ต่อเวลาในการตัดสินสกอร์
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">14. คอมโบ ปาร์เลย์</h3>
          <div className="pt-2">
            คอมโบ ปาร์เลย์ เป็นคุณสมบัติของมิกซ์ปาร์เลย์ที่ให้ความสะดวกแก่คุณในการ
            วางเดิมพันหลายรูปแบบจากเหตุการณ์ที่คุณเลือก ในการใช้คุณสมบัติคอมโบ
            ปาร์เลย์ คุณต้องเลือก 3 ถึง 8 เหตุการณ์หรือการแข่งขันที่แตกต่างกันที่
            เปิดให้เดิมพันจากหน้าตลาดมิกซ์ปาร์เลย์ ไม่อนุญาตให้เลือกหลายรายการจาก
            เหตุการณ์หรือการแข่งขันเดียวกันซึ่งผลลัพธ์ของรายการหนึ่งส่งผลต่ออีก
            รายการหนึ่ง จำนวนเหตุการณ์ที่คุณเลือกจะส่งผลต่อประเภทของคุณสมบัติคอมโบ
            ปาร์เลย์ที่คุณสามารถใช้ได้ ตัวอย่างเช่น เมื่อคุณเลือก 4 เหตุการณ์:
          </div>
          <ol type="1" className="pt-2">
            <li>
              1. <b>Event A</b> (Manchester City vs West Ham United)
            </li>
            <li>
              2. <b>Event B</b> (Cittadella vs Hellas Verona)
            </li>
            <li>
              3. <b>Event C</b> (Cordoba vs Osasuna)
            </li>
            <li>
              4. <b>Event D</b> (Liverpool vs Tottenham Hotspur)
            </li>
          </ol>
          <div className="py-3">จากเหตุการณ์ข้างต้น คุณสามารถเลือกใช้:</div>
          <div className="pl-4">
            <ul className="pb-3 list-disc">
              <li>
                <b>Double</b> (6 เดิมพัน - 6 รูปแบบของ <b>AB</b>, <b>AC</b>,{" "}
                <b>AD</b>, <b>BC</b>, <b>BD</b>, และ <b>CD</b>)
              </li>
              <li>
                <b>Treble</b> (4 เดิมพัน - 4 รูปแบบของ <b>ABC</b>, <b>ABD</b>,{" "}
                <b>ACD</b>, และ <b>BCD</b>)
              </li>
              <li>
                <b>4-Folds</b> (1 เดิมพัน - 1 รูปแบบของ <b>ABCD</b>)
              </li>
              <li>
                <b>Double</b>, <b>Treble</b>, และ <b>4-Folds</b> (รวม 11 เดิมพัน)
              </li>
            </ul>
          </div>
          <div className="pb-3 overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>จำนวนเหตุการณ์ที่เลือก</th>
                  <th>DOUBLE</th>
                  <th>TREBLE</th>
                  <th>4-FOLDS</th>
                  <th>5-FOLDS</th>
                  <th>6-FOLDS</th>
                  <th>7-FOLDS</th>
                  <th>8-FOLDS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>3</td>
                  <td>3 เดิมพัน</td>
                  <td>1 เดิมพัน</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>6 เดิมพัน</td>
                  <td>4 เดิมพัน</td>
                  <td>1 เดิมพัน</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>10 เดิมพัน</td>
                  <td>10 เดิมพัน</td>
                  <td>5 เดิมพัน</td>
                  <td>1 เดิมพัน</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>15 เดิมพัน</td>
                  <td>20 เดิมพัน</td>
                  <td>15 เดิมพัน</td>
                  <td>6 เดิมพัน</td>
                  <td>1 เดิมพัน</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>21 เดิมพัน</td>
                  <td>35 เดิมพัน</td>
                  <td>35 เดิมพัน</td>
                  <td>21 เดิมพัน</td>
                  <td>7 เดิมพัน</td>
                  <td>1 เดิมพัน</td>
                  <td></td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>28 เดิมพัน</td>
                  <td>56 เดิมพัน</td>
                  <td>70 เดิมพัน</td>
                  <td>56 เดิมพัน</td>
                  <td>28 เดิมพัน</td>
                  <td>8 เดิมพัน</td>
                  <td>1 เดิมพัน</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">15. ASIAN 1X2</h3>
          <div className="pt-2">
            ใน Asian 1X2 คุณสามารถเดิมพันบนทีมใดทีมหนึ่งหรือผลเสมอได้ เมื่อคุณ
            วางเดิมพัน ประตูที่มีอยู่ก่อนการยืนยันบิลเดิมพันของคุณจะถูกหักลบ
            <br />
            หากคุณเดิมพันใน European 1X2 คุณกำลังเดิมพันเฉพาะผลลัพธ์สุดท้ายของ
            เหตุการณ์เท่านั้น
            <br />
            ตัวอย่างเช่น ในการแข่งขันระหว่าง Japan และ England, England กำลังนำ
            Japan อยู่ 0:1 (อ้างอิงเหตุการณ์ข้างต้น 1 = Japan, X = เสมอ, และ 2 =
            England)
          </div>
          <div className="py-3">
            ในกรณีที่คุณวางเดิมพันบน Japan ใน Asian 1X2
          </div>
          <div className="overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>สกอร์เต็มเวลา (Japan vs. England)</th>
                  <th>สกอร์เมื่อวางเดิมพัน</th>
                  <th>สกอร์เต็มเวลา (Japan vs. England)</th>
                  <th>ผลการเดิมพัน</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1 : 1</td>
                  <td>0 : 1</td>
                  <td>1 : 0</td>
                  <td>ชนะ</td>
                </tr>
                <tr>
                  <td>0 : 2</td>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>แพ้</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="py-3">
            ในกรณีที่คุณวางเดิมพันบน <b>เสมอ</b> ใน Asian 1X2
          </div>
          <div className="overflow-x-auto">
            <table className="border-collapse [&_th]:border [&_td]:border [&_th]:px-2 [&_td]:px-2 [&_th]:py-1 [&_td]:py-1 [&_td]:text-center">
              <thead>
                <tr>
                  <th>สกอร์เต็มเวลา (Japan vs. England)</th>
                  <th>สกอร์เมื่อวางเดิมพัน</th>
                  <th>สกอร์เต็มเวลา (Japan vs. England)</th>
                  <th>ผลการเดิมพัน</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>0 : 0</td>
                  <td>ชนะ</td>
                </tr>
                <tr>
                  <td>0 : 2</td>
                  <td>0 : 1</td>
                  <td>0 : 1</td>
                  <td>แพ้</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">B. กฎกีฬาทั่วไป</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>
        <div className="pt-2">
          เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎการเดิมพันเฉพาะกีฬา กฎกีฬาทั่วไปต่อไปนี้
          จะถูกนำมาใช้:
        </div>

        <div className="pt-4">
          <h4 className="font-bold">1. การบังคับใช้ของกฎ</h4>
          <div className="pt-2">
            การเดิมพันทั้งหมดที่ผู้ให้บริการรับอยู่ภายใต้กฎเหล่านี้
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            2. ความไม่สอดคล้องระหว่างภาษาอังกฤษ &amp; ภาษาอื่น
          </h4>
          <div className="pt-2">
            ในกรณีที่มีความไม่สอดคล้องกันระหว่างชื่อภาษาอังกฤษและชื่อภาษาที่ไม่ใช่
            ภาษาอังกฤษที่ใช้บนเว็บไซต์ ให้ถือฉบับภาษาอังกฤษเป็นหลัก
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">3. การตีความกฎ</h4>
          <div className="pt-2">
            หากมีข้อพิพาทเกี่ยวกับการตีความกฎเหล่านี้ ให้ถือการตีความกฎเหล่านี้ของ
            ผู้ให้บริการเป็นหลัก
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">4. รูปแบบการเดิมพัน</h4>
          <div className="pt-2">
            เรารับเฉพาะการเดิมพันที่ทำบนเว็บไซต์ WAP หรือผ่านการจัดเตรียมล่วงหน้า
            ทางโทรศัพท์เท่านั้น
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">5. รายละเอียดเหตุการณ์</h4>
          <div className="pt-2">
            รายละเอียดเหตุการณ์ (วันที่ สถานที่สนามกลาง การเริ่มต้น ตัวจับเวลา
            ใบแดง ข้อมูลสถิติของผู้เล่นและทีม หรือข่าวสาร) ที่แสดงบนเว็บไซต์
            (รวมถึงรายละเอียดที่แสดงใน Live Center) มีไว้เพื่อข้อมูลทั่วไปเท่านั้น
            เป็นความรับผิดชอบของผู้ใช้ปลายทางที่จะต้องตรวจสอบและยืนยันว่ารายละเอียด
            ดังกล่าวถูกต้องก่อนวางเดิมพัน ผู้ให้บริการไม่รับผิดชอบต่อข้อผิดพลาด
            ความผิดพลาด ความล่าช้าของเวลา หรือการตกหล่นใด ๆ ในรายละเอียดเหตุการณ์
            หรือสตรีมวิดีโอที่แสดงหรือเข้าถึงบนเว็บไซต์
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">6. เดิมพันสูงสุด</h4>
          <div className="pt-2">
            จำนวนสูงสุดของการเดิมพันแต่ละครั้งจะแตกต่างกันไปตามประเภทการเดิมพัน
            เฉพาะและอาจมีการเปลี่ยนแปลงได้โดยผู้ให้บริการไม่ต้องแจ้งล่วงหน้า
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">7. การเปลี่ยนสถานที่</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>7.1</div>
              <div className="pl-3">
                ในกรณีที่มีการเปลี่ยนสถานที่ (ทีมเหย้าเล่นเป็นทีมเยือนหรือในทางกลับกัน)
                การเดิมพันทั้งหมดในการแข่งขันนั้นจะเป็นโมฆะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>7.2</div>
              <div className="pl-3">
                หากการแข่งขันมีกำหนดเล่นในสนามกลาง แต่กลับเล่นในสนามที่ไม่ใช่
                สนามกลาง (หรือในทางกลับกัน) การเดิมพันทั้งหมดยังคงมีผล
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">8. การเริ่ม/เริ่มเล่นก่อนกำหนด</h4>
          <div className="pt-2">
            การเดิมพันทั้งหมดที่วางก่อนเกมที่กำหนดเริ่มต้นถือว่ามีผล การเดิมพันที่
            วางหลังจากเกมที่กำหนดเริ่มต้นแล้วจะเป็นโมฆะ เว้นแต่การเดิมพันนั้นวางเป็น
            ส่วนหนึ่งของบริการเดิมพันแบบ In Running ("Live")
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">9. ความผันผวนของอัตราต่อรอง</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>9.1</div>
              <div className="pl-3">
                อัตราต่อรองทั้งหมดของผู้ให้บริการอาจมีความผันผวนได้ตลอดเวลา การ
                เดิมพันจะมีผลต่อเมื่ออัตราต่อรองที่ผู้ใช้ปลายทางเลือกได้ถูกส่งและ
                ผู้ให้บริการรับเรียบร้อยแล้วเท่านั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                หากอัตราต่อรองที่ผู้ใช้ปลายทางเลือกเปลี่ยนเป็นอัตราต่อรองที่ดีกว่า
                ในทางที่เป็นประโยชน์แก่ผู้ใช้ปลายทาง ระหว่างการส่งเดิมพันและการที่
                ผู้ให้บริการรับเดิมพัน การเดิมพันของผู้ใช้ปลายทางจะได้รับการยอมรับ
                ที่อัตราต่อรองที่ดีกว่า
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">10. ประเภทอัตราต่อรอง</h4>
          <div className="pt-2">
            ผู้ให้บริการเปิดให้เดิมพันด้วยประเภทอัตราต่อรองต่อไปนี้:
          </div>
          <ol type="A" className="pt-2">
            <li className="pt-2 pl-3">(A) อัตราต่อรองยุโรป</li>
            <li className="pt-2 pl-3">(B) อัตราต่อรองมาเลย์</li>
            <li className="pt-2 pl-3">(C) อัตราต่อรองอินโด</li>
            <li className="pt-2 pl-3">(D) อัตราต่อรองฮ่องกง</li>
            <li className="pt-2 pl-3">(E) อัตราต่อรองเมียนมาร์</li>
          </ol>
          <div className="pt-2 pb-2">
            สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเภทอัตราต่อรองต่าง ๆ โปรดติดต่อแผนก
            บริการลูกค้าของเราหรือดูบทแนะนำบนเว็บไซต์
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">11. กฎ 72 ชั่วโมง</h4>
          <div className="pt-2">
            ผลทั้งหมดที่ประกาศจะถือเป็นที่สิ้นสุดหลังจาก 72 ชั่วโมง และจะไม่รับ
            พิจารณาข้อสอบถามใด ๆ หลังจากช่วงเวลาดังกล่าว
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">12. เหตุการณ์ที่ถูกยกเลิก</h4>
          <div className="pt-2">
            หากเหตุการณ์ถูกยกเลิกด้วยเหตุผลใดก็ตามก่อนเริ่มต้น การเดิมพันทั้งหมดที่
            วางสำหรับเหตุการณ์นั้นจะเป็นโมฆะและจะคืนเงินที่อัตราต่อรอง 1.00
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            13. เหตุการณ์ที่ถูกเลื่อน ระงับ หรือไม่สมบูรณ์ (กฎ 12 ชั่วโมง)
          </h4>
          <div className="pt-2">
            การเดิมพันทั้งหมดที่วางจะคืนเงินเดิมพันหากเหตุการณ์ถูกระงับหรือเลื่อน
            ออกไป และไม่กลับมาเล่นภายใน 12 ชั่วโมงนับจากเวลาที่กำหนดเริ่มต้น (เว้นแต่
            จะระบุไว้เป็นอย่างอื่นในกฎกีฬาเฉพาะ) ข้อยกเว้นคือการเดิมพันที่ได้ถูก
            ตัดสินอย่างไม่มีเงื่อนไขก่อนการหยุดเล่นจริง ในกรณีดังกล่าว การเดิมพัน
            นั้นจะมีผล
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">14. การระงับตลาด</h4>
          <div className="pt-2">
            ผู้ให้บริการขอสงวนสิทธิ์ในการระงับตลาดหรือไม่รับเดิมพันได้ตลอดเวลา เมื่อ
            ตลาดถูกระงับ การเดิมพันใด ๆ ที่วางสำหรับตลาดนั้นแต่ยังไม่ได้รับการยอมรับ
            จากผู้ให้บริการจะถูกปฏิเสธ ผู้ให้บริการยังขอสงวนสิทธิ์ในการยุติการเดิมพัน
            บนตลาดใด ๆ ได้ตลอดเวลาโดยไม่ต้องแจ้งล่วงหน้า
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">15. การทำให้เดิมพันเป็นโมฆะเนื่องจากความผิดพลาดหรือข้อผิดพลาด</h4>
          <div className="pt-2">
            หากมีการระบุผู้เข้าแข่งขันที่ไม่ถูกต้อง (หรือสมาชิกที่ไม่ถูกต้องของทีมที่
            เข้าร่วม) หรืออัตราต่อรอง/ราคาที่ไม่ถูกต้องสำหรับเหตุการณ์ใด ๆ หรือ
            ผู้ให้บริการได้อาศัยข้อมูลที่ไม่ถูกต้องในการกำหนดอัตราต่อรองหรือการเดิมพัน
            หรือมีการป้อนสกอร์หรือรายละเอียดที่ผิดในระหว่างเซสชันการเดิมพันแบบ In
            Running ("Live") หรือมีการรับเดิมพันโดยผิดพลาด ผู้ให้บริการขอสงวนสิทธิ์
            ในการทำให้การเดิมพันดังกล่าวหรือทั้งหมดที่วางสำหรับเหตุการณ์นั้นหรือบน
            ผู้เข้าแข่งขันนั้นเป็นโมฆะ
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">16. การคืนเงินเดิมพันเนื่องจากเดิมพันเป็นโมฆะ</h4>
          <div className="pt-2">
            การเดิมพันทั้งหมดที่ถูกประกาศเป็นโมฆะจะส่งผลให้มีการคืนเงินเดิมพัน
            เริ่มต้น
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">17. การเดิมพันที่ผิดปกติ</h4>
          <div className="pt-2">
            ผู้ให้บริการขอสงวนสิทธิ์ในการปฏิเสธ ไม่รับ หรือระงับโดยไม่ต้องแจ้งล่วงหน้า
            ต่อผู้ใช้ปลายทางที่ถูกสงสัยว่าโกง แฮ็ก โจมตี บิดเบือน หรือทำลายการดำเนินงาน
            การเดิมพันตามปกติของผู้ให้บริการ (รวมถึงเว็บไซต์) "การเดิมพันที่ผิดปกติ"
            ใด ๆ จะเป็นโมฆะโดยไม่ต้องแจ้งล่วงหน้า ห้ามใช้ปัญญาประดิษฐ์หรือ "บอท" บน
            เว็บไซต์โดยเด็ดขาด ผู้ให้บริการจะดำเนินมาตรการเพื่อป้องกันและตรวจจับ
            โปรแกรมที่ใช้เพื่อให้ปัญญาประดิษฐ์ (ที่ไม่ใช่มนุษย์) ใช้งานเว็บไซต์ การ
            พยายามหรือการใช้ปัญญาประดิษฐ์จริงโดยผู้ใช้ปลายทางเพื่อโกง แฮ็ก โจมตี
            บิดเบือน หรือทำลายการดำเนินงานการเดิมพันของผู้ให้บริการ จะนำไปสู่การยุติ
            บัญชีของพวกเขาและ/หรือการทำให้การเดิมพันเป็นโมฆะ ตามดุลยพินิจของ
            ผู้ให้บริการ
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">18. การเดิมพันมิกซ์ปาร์เลย์ที่ไม่สมบูรณ์</h4>
          <div className="pt-2">
            หากเหตุการณ์หรือเกมในการเดิมพันมิกซ์ปาร์เลย์ถูกยกเลิก ไม่ได้เกิดขึ้น หรือ
            ไม่เสร็จสมบูรณ์ด้วยเหตุผลใดก็ตาม องค์ประกอบที่ถูกยกเลิก/ไม่ได้เข้าร่วม
            ของการเดิมพันจะเป็นโมฆะ แต่องค์ประกอบที่เหลือของการเดิมพันมิกซ์ปาร์เลย์
            จะยังคงมีผลโดยมีการคำนวณอัตราต่อรองใหม่
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">19. การตัดสินการเดิมพัน</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>19.1</div>
              <div className="pl-3">
                ผู้ชนะของเหตุการณ์จะถูกตัดสินจากผลที่เกี่ยวข้องเมื่อสิ้นสุดเหตุการณ์
                การตัดสินและชำระผลผู้ชนะของเหตุการณ์ และการตัดสินและชำระผลการเดิมพัน
                ทั้งหมด ตามประเภทการเดิมพันและข้อกำหนดและเงื่อนไขที่เกี่ยวข้องกับ
                ประเภทการเดิมพันนั้น จะกระทำเมื่อสิ้นสุดเหตุการณ์และหลังจากตรวจสอบและ
                ยืนยันผลที่เกี่ยวข้องทั้งหมดแล้ว ผู้ให้บริการจะใช้ความพยายามอย่างดี
                ที่สุดในการตรวจสอบและยืนยันผลที่เกี่ยวข้องทั้งหมดโดยเร็วที่สุดเท่าที่
                เหมาะสมหลังจากสิ้นสุดเหตุการณ์ เมื่อผลที่เกี่ยวข้องถูกตรวจสอบ ยืนยัน
                และประกาศแล้ว การประท้วง อุทธรณ์ หรือการพลิกคำตัดสินที่เกิดขึ้น
                ภายหลังจะไม่ได้รับการยอมรับเพื่อวัตถุประสงค์ในการเดิมพัน
              </div>
            </li>
            <li className="flex pt-2">
              <div>19.2</div>
              <div className="pl-3">
                แม้จะมีกฎใด ๆ ที่ระบุไว้ในกฎการเดิมพันเฉพาะกีฬา กฎการเดิมพันกีฬา และ
                กฎกีฬาทั่วไปเหล่านี้ ผู้ให้บริการอาจใช้ดุลยพินิจของตนแต่เพียงผู้เดียว
                ในการตัดสินและ/หรือชำระผลการเดิมพันใด ๆ ตามประเภทการเดิมพันและ
                ข้อกำหนดและเงื่อนไขที่เกี่ยวข้องกับประเภทการเดิมพันนั้น ๆ ได้ตลอดเวลา
                และเป็นครั้งคราว ก่อนสิ้นสุดเกม/การแข่งขัน/เหตุการณ์ใด ๆ หากการ
                เดิมพันนั้นสามารถตัดสินได้อย่างไม่มีเงื่อนไข ณ เวลาที่ผู้ให้บริการ
                ทำการตัดสิน
              </div>
            </li>
            <li className="flex pt-2">
              <div>19.3</div>
              <div className="pl-3">
                ไม่มีข้อความใดในข้อ 19.1 และ/หรือ 19.2 ข้างต้นที่กระทบต่อสิทธิ์ของ
                ผู้ให้บริการในการถือว่าการเดิมพันที่ตัดสินและ/หรือชำระผลแล้วเป็นการ
                ตัดสินและ/หรือชำระผลที่ไม่ถูกต้อง การตัดสินและ/หรือการชำระผลที่ไม่
                ถูกต้องดังกล่าวจะเป็นโมฆะและถูกยกเลิกโดยผู้ให้บริการ ซึ่งเมื่อนั้น
                ผู้ให้บริการจะตัดสินใหม่และ/หรือชำระผลใหม่สำหรับการเดิมพันที่ได้รับ
                ผลกระทบเหล่านี้ตามข้อกำหนดและเงื่อนไขที่บังคับใช้ของผู้ให้บริการ
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">20. กฎ DEAD HEAT</h4>
          <div className="pt-2">
            หากมีผู้ชนะตั้งแต่สองรายขึ้นไป อัตราต่อรองการจ่ายเงิน (หักเงินเดิมพัน)
            จะถูกหารด้วยจำนวนผู้ชนะและชำระผลตามนั้นพร้อมคืนเงินเดิมพัน
          </div>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">21. การแข่งขันแฟนตาซี</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>21.1</div>
              <div className="pl-3">
                การเดิมพันการแข่งขันแฟนตาซีเกี่ยวข้องกับการจับคู่เสมือนของสองทีมใด ๆ
                ผลการแข่งขันแฟนตาซีตัดสินจากจำนวนประตู/แต้มที่ทำได้โดยสองทีมที่
                จับคู่กันในการแข่งขันของแต่ละทีม ทีมที่ชนะคือทีมที่มีจำนวนประตู/แต้ม
                สูงสุด รวมแต้มต่อ (หากมี)
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.2</div>
              <div className="pl-3">
                ทีมที่ถูกจับคู่ในการแข่งขันแฟนตาซีต้องเริ่มการแข่งขันของตนในวัน
                เดียวกัน แม้ว่าการแข่งขันหนึ่งอาจจบช้ากว่าอีกการแข่งขันหนึ่ง แต่ทั้ง
                สองการแข่งขันต้องเล่นในเซสชันต่อเนื่องเดียว (กล่าวคือ ไม่มีการแข่งขัน
                ที่ถูกเลื่อน เลื่อนกำหนด หรือยกเลิก) เพื่อให้การเดิมพันมีผล
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.3</div>
              <div className="pl-3">
                ภายใต้กฎ 19.2 ข้างต้น หากการแข่งขันของทีมที่จับคู่กันใด ๆ ถูกเลื่อน
                เลื่อนกำหนด หรือยกเลิก การเดิมพันการแข่งขันแฟนตาซีทั้งหมดที่เกี่ยวข้อง
                กับทีมเหล่านั้นจะเป็นโมฆะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.4</div>
              <div className="pl-3">
                สถานที่ (เหย้าหรือเยือน) ของการแข่งขันจะไม่ถูกพิจารณาในการแข่งขัน
                แฟนตาซีเหล่านี้
              </div>
            </li>
            <li className="flex pt-2">
              <div>21.5</div>
              <div className="pl-3">
                เว้นแต่ที่ระบุไว้ข้างต้น กฎการแข่งขันแฟนตาซีจะเป็นไปตามกฎของกีฬา
                เฉพาะที่เปิดให้เดิมพันการแข่งขันแฟนตาซี
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">
            22. ผล/สกอร์ที่ไม่สอดคล้องกับผลอย่างเป็นทางการ
          </h4>
          <ol className="pt-2">
            <li className="flex">
              <div>22.1</div>
              <div className="pl-3">
                ในกรณีที่มีความขัดแย้งระหว่างผลการแข่งขันอย่างเป็นทางการกับผลบน
                เว็บไซต์ของผู้ให้บริการ ผู้ให้บริการขอสงวนสิทธิ์ในการระงับการตัดสิน
                และ/หรือการชำระผลการเดิมพันดังกล่าวได้นานถึง 72 ชั่วโมงหรือช่วงเวลา
                อื่นที่จำเป็นในระหว่างรอการยืนยันผล/สกอร์
              </div>
            </li>
            <li className="flex pt-2">
              <div>22.2</div>
              <div className="pl-3">
                ความขัดแย้งจะได้รับการแก้ไขโดยการอ้างอิงการบันทึกวิดีโอของการแข่งขัน/
                เหตุการณ์ และการตัดสินสกอร์/ผลที่ถูกต้องใด ๆ จากการบันทึกวิดีโอ
                ดังกล่าวจะมีผลเหนือกว่าผลการแข่งขันอย่างเป็นทางการ
              </div>
            </li>
            <li className="flex pt-2">
              <div>22.3</div>
              <div className="pl-3">
                ในกรณีที่ไม่มีการบันทึกวิดีโอ สกอร์/ผลที่ถูกต้องจะถูกตัดสินโดยการ
                อ้างอิงสกอร์/ผลที่ประกาศบนเว็บไซต์อย่างเป็นทางการขององค์กรกำกับดูแล
                กีฬานั้น เว้นแต่ผลที่ประกาศบนเว็บไซต์อย่างเป็นทางการจะผิดอย่างชัดเจน
                ซึ่งในกรณีนั้นผู้ให้บริการจะใช้ความพยายามอย่างดีที่สุดในการตัดสินผล
                ที่ถูกต้องเพื่อใช้ในการตัดสินผู้ชนะและ/หรือผล ในกรณีดังกล่าว การ
                ตัดสินของผู้ให้บริการถือเป็นที่สิ้นสุด
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h4 className="font-bold">23. บริการเดิมพันแบบ IN RUNNING ("LIVE")</h4>
          <ol className="pt-2">
            <li className="flex">
              <div>23.1</div>
              <div className="pl-3">
                การเดิมพันแบบ In Running ("Live") มีให้เฉพาะกีฬาที่ผู้ให้บริการกำหนด
                ให้เป็นตลาดเดิมพันสด และเฉพาะการแข่งขันที่ถูกทำเครื่องหมายว่า "live"
                หรือ "live bets" หรือด้วยสัญลักษณ์ LIVE ในรายการเหตุการณ์ หรือในไฟล์
                พิเศษที่มีชื่อว่า "LIVE" บนเว็บไซต์เท่านั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.2</div>
              <div className="pl-3">
                การเดิมพันแบบ In Running ("Live") คือการที่ผู้ใช้ปลายทางได้รับอนุญาต
                ให้วางเดิมพันในระหว่างการแข่งขันหรือเหตุการณ์ที่กำลังดำเนินอยู่ จนถึง
                เวลาที่ผู้ให้บริการยุติการเดิมพันบนการแข่งขันหรือเหตุการณ์นั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.3</div>
              <div className="pl-3">
                ในการเดิมพันแบบ In Running ("Live") สำหรับการเดิมพันอัตราต่อรองแบบ
                เอเชียน (Asian Handicap) จะมีระบบการให้คะแนนสองประเภทแสดงบนเว็บไซต์:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) ระบบที่สกอร์หรือผลปัจจุบันถูกอัปเดตและแสดง ("Type A Scoring")
                การชำระผลการเดิมพันจะตัดสินจากผลของสกอร์สุดท้าย (รวมแต้มต่อ) เมื่อ
                สิ้นสุดการแข่งขันหรือการเดิมพันรายช่วง (ขึ้นอยู่กับลักษณะของการ
                เดิมพัน) ลบด้วยสกอร์ปัจจุบัน ณ เวลาที่วางและรับการเดิมพัน
              </li>
              <li className="pt-2 pl-3">
                (B) ระบบที่สกอร์หรือผลปัจจุบันไม่ถูกแสดง และจะแสดงสกอร์หรือผล 0-0
                แทน ("Type B Scoring") การชำระผลการเดิมพันจะตัดสินจากผลของสกอร์
                สุดท้าย (รวมแต้มต่อ) เมื่อสิ้นสุดการแข่งขันหรือการเดิมพันรายช่วง
                (ขึ้นอยู่กับลักษณะของการเดิมพัน) ผู้ใช้ปลายทางควรตรวจสอบสถานะการ
                แข่งขันก่อนวางเดิมพัน
              </li>
            </ol>
            <li className="flex pt-2">
              <div>23.4</div>
              <div className="pl-3">
                ขึ้นอยู่กับกีฬาเฉพาะ ตลาดที่เลือกอาจเปิดให้เดิมพันตามดุลยพินิจของ
                ผู้ให้บริการแต่เพียงผู้เดียว ผู้ให้บริการไม่รับรู้หรือรับผิดชอบใด ๆ
                หากไม่สามารถวางเดิมพันได้ หรือหากการอัปเดตสกอร์สดไม่ถูกต้อง สกอร์
                หรือผลที่แสดงเมื่อสิ้นสุดการแข่งขันคือสิ่งที่มีผล
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.5</div>
              <div className="pl-3">
                ตลอดเวลา เป็นความรับผิดชอบของผู้ใช้ปลายทางที่จะต้องรับทราบสกอร์ และ
                ควรตรวจสอบสถานะการแข่งขันก่อนวางเดิมพัน
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.6</div>
              <div className="pl-3">
                เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎการเดิมพันเฉพาะกีฬา ข้อมูล สถิติ
                หรือข้อความบรรณาธิการใด ๆ (เช่น สกอร์ ตัวจับเวลา หรือผล) ที่แสดงบน
                เว็บไซต์ในระหว่างสถานการณ์เกมแบบ In Running ("Live") มีไว้เพื่อ
                วัตถุประสงค์ข้อมูลทั่วไปล้วน ๆ และไม่ควรนำมาใช้เพื่อวัตถุประสงค์ใน
                การเดิมพัน
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.7</div>
              <div className="pl-3">
                เช่นเดียวกับการเดิมพันที่ไม่ใช่แบบสด ผู้ชนะของเหตุการณ์จะถูกตัดสินจาก
                ผลที่เกี่ยวข้องเมื่อสิ้นสุดเหตุการณ์ การประท้วง อุทธรณ์ หรือการพลิก
                คำตัดสินจะไม่ได้รับการยอมรับเพื่อวัตถุประสงค์ในการเดิมพัน และการ
                เปลี่ยนแปลงผลที่เกิดขึ้นภายหลังจะไม่ส่งผลต่อผลลัพธ์ของการเดิมพัน
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.8</div>
              <div className="pl-3">
                ผู้ให้บริการขอสงวนสิทธิ์ในการระงับตลาดหรือไม่รับเดิมพันได้ตลอดเวลา
                โดยไม่ต้องแจ้งล่วงหน้า เมื่อตลาดถูกระงับ การเดิมพันใด ๆ ที่วางสำหรับ
                ตลาดนั้นแต่ยังไม่ได้รับการยอมรับจากผู้ให้บริการอาจถูกปฏิเสธตามดุลยพินิจ
                ของผู้ให้บริการ การเดิมพันใด ๆ ที่รับก่อนการระงับหรือการยุติตลาดสด
                จะยังคงมีผล ในขณะที่การเดิมพันใด ๆ ที่วางหลังจากการเดิมพันสดยุติลงแล้ว
                จะไม่ได้รับการยอมรับ เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎการเดิมพันเฉพาะ
                กีฬา
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.9</div>
              <div className="pl-3">
                ในระหว่างเงื่อนไขการเดิมพันแบบ In Running ("Live"):
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่วางจะถูกเก็บไว้ในโหมดรอดำเนินการ:
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) เมื่อผู้ให้บริการเห็นว่าอาจมีการเกิดช่วงเวลาที่มีความเสี่ยงสูง
                    / อันตราย; หรือ
                  </li>
                  <li className="pt-2 pl-3">
                    (II) ก่อนและในระหว่างช่วงเวลาที่มีความเสี่ยงสูง / อันตรายในการ
                    แข่งขัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันที่กล่าวถึงในกฎ B23.9(a) ข้างต้นจะถูกระบุว่า "รอ
                ดำเนินการ" บนแต่ละบิลเดิมพัน จนถึงเวลาที่การเดิมพันได้รับการยอมรับ
                หรือถูกปฏิเสธโดยผู้ให้บริการตามดุลยพินิจของผู้ให้บริการแต่เพียงผู้เดียว
              </li>
              <li className="pt-2 pl-3">
                (C) ช่วงเวลาที่มีความเสี่ยงสูง / อันตราย กำหนดไว้ดังนี้:
                <ol type="I">
                  <li className="pt-2 pl-3">(I) การเตะมุม;</li>
                  <li className="pt-2 pl-3">(II) การเตะจุดโทษ;</li>
                  <li className="pt-2 pl-3">
                    (III) ฟรีคิกที่ได้รับให้แก่ทีมที่กำลังบุก ใกล้กับเขตโทษของฝ่าย
                    ตรงข้าม;
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) การทุ่มที่ได้รับให้แก่ทีมที่กำลังบุก ใกล้กับเขตโทษของฝ่าย
                    ตรงข้าม;
                  </li>
                  <li className="pt-2 pl-3">
                    (V) เมื่อใดก็ตามที่ทีมอยู่ในสถานการณ์ที่อาจทำประตูได้ เช่น ในโหมด
                    บุกที่กำลังดำเนินอยู่; หรือ
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) ตามที่ผู้ให้บริการอาจตัดสินตามดุลยพินิจของตนแต่เพียงผู้เดียว
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (D) การเดิมพัน Fast Market ทั้งหมดจะไม่อยู่ภายใต้กฎ B23.9 (a) ถึง
                (c) ข้างต้น ซึ่งการเดิมพันดังกล่าวจะได้รับการยอมรับโดยไม่ถูกเก็บไว้
                ในโหมดรอดำเนินการ
              </li>
            </ol>
            <li className="flex pt-2">
              <div>23.10</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดบนอัตราต่อรองแบบเอเชียน (Asian Handicap) และสูง/ต่ำ
                ที่อยู่ในโหมดรอดำเนินการ (นอกเหนือจากการเดิมพันบนใบเตือนรวม เตะมุมรวม
                ล้ำหน้ารวม การเปลี่ยนตัวรวม และ/หรือการเดิมพันที่ไม่มีผลต่อผลโดยรวม
                ของการแข่งขัน) จะถูกยกเลิกหากเกิดเหตุการณ์ใดเหตุการณ์หนึ่งต่อไปนี้:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) มีการทำประตู; หรือ</li>
              <li className="pt-2 pl-3">(B) มีผู้เล่นถูกไล่ออก</li>
            </ol>
            <li className="flex pt-2">
              <div>23.11</div>
              <div className="pl-3">
                การเดิมพันอื่น ๆ ทั้งหมด เช่น ใบเตือนรวม เตะมุมรวม ล้ำหน้ารวม การ
                เปลี่ยนตัวรวม และ/หรือการเดิมพันที่ไม่มีผลต่อผลโดยรวมของการแข่งขัน
                อาจได้รับการยอมรับตามดุลยพินิจของผู้ให้บริการ
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.12</div>
              <div className="pl-3">
                ผู้ให้บริการจะเป็นผู้ตัดสินตามดุลยพินิจของตนแต่เพียงผู้เดียวว่าประตู
                หรือแต้มใดทำได้ในเวลาใด การอ้างอิงเวลาของประตูหรือแต้มที่ทำได้ตามที่
                ระบุบนเว็บไซต์ลีก/สโมสรอย่างเป็นทางการ เว็บไซต์สื่อ หรือเว็บไซต์
                "live score" อาจถูกพิจารณาเพื่อเป็นแนวทาง แต่จะไม่ผูกพันผู้ให้บริการ
                ในการตัดสินเวลา
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.13</div>
              <div className="pl-3">
                ในกรณีที่ผู้ให้บริการมีเหตุผลที่จะเชื่อหรือสงสัยว่ามีการวางเดิมพันสด
                หลังจากที่ผลของเหตุการณ์สดเป็นที่ทราบแล้ว หรือหากการถ่ายทอด
                โทรทัศน์ "สด" ที่ล่าช้าส่งผลให้มีการวางเดิมพันสดที่ราคาไม่ถูกต้อง
                หลังจากที่ผู้เข้าแข่งขันที่เลือกได้เปรียบ (ซึ่งจะตัดสินตามดุลยพินิจ
                ของผู้ให้บริการแต่เพียงผู้เดียว) ผู้ให้บริการมีสิทธิ์ที่จะถือว่าการ
                เดิมพันเป็นโมฆะได้โดยไม่ต้องให้เหตุผลใด ๆ ทั้งสิ้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.14</div>
              <div className="pl-3">
                ในกรณีที่เกิดความขัดข้องทางเทคนิคใด ๆ รวมถึงการที่เว็บไซต์ล่ม หรือ
                การหยุดทำงานใด ๆ ที่ขัดขวาง ทำให้ล่าช้า หรือป้องกันไม่ให้ผู้ให้บริการ
                เข้าถึงเว็บไซต์เพื่ออัปเดตสกอร์ อัตราต่อรอง หรือแต้มต่อ ผู้ให้บริการ
                ขอสงวนสิทธิ์ในการยกเลิกการเดิมพันที่รอดำเนินการทั้งหมดที่วาง ณ เวลา
                ที่เกิดเหตุการณ์
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.15</div>
              <div className="pl-3">
                เกี่ยวกับการเดิมพันสด กฎทั่วไปที่เกี่ยวกับการประเมินผลจะถูกนำมาใช้ ใน
                กรณีที่เหตุการณ์สดถูกขัดจังหวะในระหว่างการเล่น ทำให้เหตุการณ์ถูกเลื่อน
                หรือยกเลิก การเดิมพันใด ๆ ที่รับบนเหตุการณ์ที่ถูกเลื่อนหรือยกเลิก
                ดังกล่าวที่ไม่เริ่มใหม่ภายใน 12 ชั่วโมงนับจากเวลาเริ่มต้นเหตุการณ์
                (เว้นแต่จะกำหนดไว้โดยเฉพาะในกฎการเดิมพันเฉพาะกีฬา) จะเป็นโมฆะ ข้อยกเว้น
                คือการเดิมพันที่ได้ถูกตัดสินอย่างไม่มีเงื่อนไขก่อนการหยุดเล่นจริง ใน
                กรณีดังกล่าว การเดิมพันนั้นจะมีผล
              </div>
            </li>
            <li className="flex pt-2">
              <div>23.16</div>
              <div className="pl-3">
                มิกซ์ปาร์เลย์แบบ In Running ("Live") การเดิมพันมิกซ์ปาร์เลย์แบบสด
                คือการเดิมพันมิกซ์ปาร์เลย์ที่รวมจากการเลือกการเดิมพันแบบ Live และ
                ที่ไม่ใช่ Live และอย่างน้อย 1 เกมหรือการแข่งขันต้องเป็นเหตุการณ์
                Live การเดิมพันมิกซ์ปาร์เลย์แบบสดต้องรวมจากการเลือกอย่างน้อย 3 เกม
                หรือการแข่งขันที่แตกต่างกัน การเลือกทั้งหมดต้องได้รับการยอมรับเพื่อ
                ให้การเดิมพันมิกซ์ปาร์เลย์แบบสดมีผล การปฏิเสธการเลือกใด ๆ จะส่งผลให้
                การเดิมพันมิกซ์ปาร์เลย์แบบสดถูกปฏิเสธด้วยเช่นกัน
              </div>
            </li>
          </ol>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">C. กฎการเดิมพันเฉพาะกีฬา</h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>
        <div className="pt-2">
          กฎต่อไปนี้คือกฎการเดิมพันพิเศษที่ใช้กับการเดิมพันที่วางบนกีฬาแต่ละประเภท
          และร่วมกับกฎกีฬาทั่วไปจะกำกับการใช้งานผลิตภัณฑ์การเดิมพันกีฬาแบบโต้ตอบ
          ทั้งหมดของผู้ให้บริการโดยผู้ใช้ปลายทาง
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. บาสเกตบอล</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>1.1</div>
              <div className="pl-3">
                เพื่อให้การเดิมพันมีผล ต้องเหลือเวลาเกมตามกำหนด 5 นาทีหรือน้อยกว่า
                เมื่อส่วนที่เหลือของเกมถูกยกเลิก ยกเว้นการเดิมพันที่ได้ถูกตัดสิน
                อย่างไม่มีเงื่อนไขก่อนที่เกมจะถูกยกเลิก (เช่น การเดิมพันรายช่วง)
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.2</div>
              <div className="pl-3">
                การชำระผลจะอ้างอิงจากสกอร์สุดท้ายอย่างเป็นทางการ รวมช่วงต่อเวลา
                (หากมี) เว้นแต่จะระบุไว้เป็นอย่างอื่น
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.3</div>
              <div className="pl-3">
                สำหรับ NCAAB สถานที่ "เหย้า" และ "เยือน" ที่ระบุบนเว็บไซต์มีไว้เพื่อ
                อ้างอิงเท่านั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>1.4</div>
              <div className="pl-3">นี่คือการเดิมพันที่เปิดให้สำหรับบาสเกตบอล:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">(I) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
                  <li className="pt-2 pl-3">
                    (II) ทีมที่ทำแต้มแรก
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันจะตัดสินจากทีมที่ทำแต้มแรกในการแข่งขัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) หากการแข่งขันถูกยกเลิกหลังจากทำแต้มแรกแล้ว การเดิมพัน
                        ทั้งหมดจะยังคงมีผล
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) ทีมที่ทำแต้มสูงสุดต่อควอเตอร์
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนทีมที่ทำแต้มสูงสุดในแต่ละควอเตอร์ของการแข่งขัน
                        ไม่รวมช่วงต่อเวลา
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) ทีมที่ทำแต้มสุดท้าย
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันจะตัดสินจากทีมที่ทำแต้มสุดท้ายในการแข่งขัน
                        (รวมแต้มใด ๆ ที่ทำได้ในช่วงต่อเวลา)
                      </li>
                      <li className="pt-2 pl-3">
                        (B) หากการแข่งขันถูกยกเลิก การเดิมพันทั้งหมดบนทีมที่ทำแต้ม
                        สุดท้ายจะเป็นโมฆะ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(V) คู่/คี่</li>
                  <li className="pt-2 pl-3">(VI) เอาท์ไรท์ (Outright)</li>
                  <li className="pt-2 pl-3">(VII) สูง/ต่ำ</li>
                  <li className="pt-2 pl-3">
                    (VIII) การเดิมพันรายช่วง
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันรายครึ่ง
                        <ol type="1">
                          <li className="pt-2 pl-3">
                            (1) สำหรับการเดิมพันครึ่งแรก การเดิมพันจะตัดสินจากผลรวม
                            ของสกอร์ควอเตอร์ที่ 1 และที่ 2 รวมแต้มต่อเพื่อตัดสินผู้ชนะ
                          </li>
                          <li className="pt-2 pl-3">
                            (2) สำหรับการเดิมพันครึ่งหลัง การเดิมพันจะตัดสินจากผลรวม
                            ของสกอร์ควอเตอร์ที่ 3 และที่ 4 รวมแต้มต่อเพื่อตัดสิน
                            ผู้ชนะ การเดิมพันครึ่งหลังรวมสกอร์ที่ทำได้ในช่วงต่อเวลา
                            (หากมี)
                          </li>
                        </ol>
                      </li>
                      <li className="pt-2 pl-3">
                        (B) การเดิมพันรายควอเตอร์
                        <ol type="1">
                          <li className="pt-2 pl-3">
                            (1) การเดิมพันจะตัดสินจากสกอร์ที่ทำได้เมื่อสิ้นสุดแต่ละ
                            ควอเตอร์ รวมแต้มต่อเพื่อตัดสินผู้ชนะ
                          </li>
                          <li className="pt-2 pl-3">
                            (2) สำหรับการเดิมพันควอเตอร์ที่ 4 ประตูหรือแต้มที่ทำได้
                            ในช่วงต่อเวลาจะไม่ถูกนำมารวมในการตัดสินผู้ชนะ
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IX) แข่งไปให้ถึง 20 แต้ม
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนทีมที่จะทำถึง 20 แต้มแรกในการแข่งขัน
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (X) แต้มรวม/รีบาวด์/แอสซิสต์/สตีล/บล็อกช็อต/3 แต้ม โดยทีม/ผู้เล่น:
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การชำระผลจะอ้างอิงจากสถิติของผู้เล่นหรือทีมในการแข่งขัน
                        นั้น ๆ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) การเดิมพันจะคืนเงินเดิมพันสำหรับผู้ที่ไม่ได้ลงแข่ง (กล่าว
                        คือ ผู้เล่นที่ไม่ได้เข้าร่วมในส่วนใดของการแข่งขัน)
                      </li>
                      <li className="pt-2 pl-3">
                        (C) การเดิมพันบนผู้เล่นที่ลงเล่นแต่ไม่ได้ทำแต้ม รีบาวด์ หรือ
                        แอสซิสต์ จะถือว่าทำได้ศูนย์
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันแบบ In Running ("Live")
                <ol type="I">
                  <li className="pt-2 pl-3">(I) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
                  <li className="pt-2 pl-3">(II) สูง/ต่ำ</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) ระบบการให้คะแนน
                <div className="pt-1">
                  ใช้ Type B Scoring กระดานสกอร์สดที่แสดงบนเว็บไซต์มือถือมีไว้เพื่อ
                  วัตถุประสงค์ในการอ้างอิงเท่านั้น การชำระผลการเดิมพันจะตัดสินโดย
                  ระบบ Type B Scoring
                </div>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>1.5</div>
              <div className="pl-3">การเดิมพัน e-Basketball</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎข้อ 8.5 นี้ ให้นำกฎข้อ 8 มาใช้
                กับการเดิมพัน e-Basketball
              </li>
              <li className="pt-2 pl-3">
                (B) การแข่งขัน e-Basketball เป็นการจำลองที่อาศัยปัญญาประดิษฐ์ การ
                เรียนรู้ของเครื่อง และฐานข้อมูลบาสเกตบอลในอดีต เพื่อสะท้อนฟอร์มของ
                ทีมและการเล่น
              </li>
              <li className="pt-2 pl-3">
                (C) เว้นแต่จะระบุไว้เป็นอย่างอื่น แต่ละการแข่งขันจะเล่นสี่ควอเตอร์
                ควอเตอร์ละ 12 นาที รวมเวลาการเล่นทั้งหมด 48 นาที
              </li>
              <li className="pt-2 pl-3">
                (D) ผล สกอร์ และข้อมูลตัดสินการเดิมพันอื่น ๆ ของ e-Basketball จะเป็น
                ข้อมูลที่ผลิตโดยซอฟต์แวร์ และไม่สามารถหาได้จากแหล่งอื่นใด รวมถึงจาก
                เว็บไซต์ทีมหรือลีกอย่างเป็นทางการ
              </li>
              <li className="pt-2 pl-3">
                (E) การแข่งขัน e-Basketball เป็นการแข่งขันที่ออกอากาศ และจึงถือเป็น
                การแข่งขันแบบ Common Betting ที่ผู้ใช้ปลายทางมากกว่าหนึ่งรายสามารถ
                เดิมพันบนการแข่งขันเฉพาะ และผลของการแข่งขันนี้จะตัดสินผลลัพธ์ของการ
                เดิมพันที่วางโดยผู้ใช้ปลายทางทั้งหมด
              </li>
              <li className="pt-2 pl-3">
                (F) ในกรณีที่การแข่งขันใดไม่เสร็จสมบูรณ์ภายในเวลาที่กำหนดเนื่องจาก
                ความขัดข้องทางเทคนิคใด ๆ รวมถึงแต่ไม่จำกัดเพียงความขัดข้องของ
                คอมพิวเตอร์ อิเล็กทรอนิกส์ ซอฟต์แวร์ ฮาร์ดแวร์ หรือการเชื่อมต่อ การ
                แข่งขันจะถูกชำระผลโดยผู้ให้บริการว่าไม่สมบูรณ์ ในกรณีดังกล่าวจะมีการ
                ชำระผลเฉพาะการเดิมพันที่ได้ถูกตัดสินอย่างไม่มีเงื่อนไขเท่านั้น สำหรับ
                ตลาดอื่น ๆ ทั้งหมดและโดยไม่คำนึงถึงผลที่บ่งชี้ใด ๆ การเดิมพันจะเป็น
                โมฆะและคืนเงินเดิมพันให้ผู้ใช้ปลายทาง ผู้ให้บริการจะชำระผลการแข่งขัน
                ดังกล่าวตามกฎเหล่านี้ และการตัดสินของผู้ให้บริการถือเป็นที่สิ้นสุด
              </li>
              <li className="pt-2 pl-3">
                (G) ผู้ให้บริการขอสงวนสิทธิ์ในการประกาศให้การเดิมพัน e-Basketball
                เป็นโมฆะ หาก;
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) มีรายละเอียดการเดิมพันเพียงบางส่วนหรือไม่ถูกต้องเท่านั้น;
                  </li>
                  <li className="pt-2 pl-3">
                    (II) ผู้ให้บริการมีข้อสงสัยว่าผู้ใช้ปลายทางหนึ่งรายขึ้นไปกำลัง
                    มีส่วนร่วมในการฉ้อโกง การสมรู้ร่วมคิด การฟอกเงิน หรือกิจกรรมที่
                    ผิดกฎหมายอื่น ๆ;
                  </li>
                  <li className="pt-2 pl-3">
                    (III) การแข่งขันไม่ได้เริ่มต้นหรือไม่เสร็จสมบูรณ์ หรือไม่สามารถ
                    ตัดสินผลได้;
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) การยอมรับการเดิมพันจะเกินขีดจำกัดการเดิมพันใด ๆ;
                  </li>
                  <li className="pt-2 pl-3">
                    (V) จำนวนเงินเดิมพันไม่มีในบัญชีของผู้ใช้ปลายทาง;
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) ข้อผิดพลาด (จากมนุษย์หรืออื่น ๆ) หรือความล้มเหลวของระบบ
                    ส่งผลให้มีการใช้อัตราต่อรองที่ไม่ถูกต้อง;
                  </li>
                  <li className="pt-2 pl-3">
                    (VII) เกิดข้อบกพร่องทางเทคนิค เช่น ความล้มเหลวในการสื่อสาร
                    ข้อบกพร่อง การขัดจังหวะ ความล่าช้า ไวรัส การโจมตีแบบปฏิเสธการ
                    ให้บริการ หรือข้อมูลเสียหาย; หรือ
                  </li>
                  <li className="pt-2 pl-3">
                    (VIII) หากข้อบกพร่องทางเทคนิคก่อให้เกิดเงินรางวัลที่มากเกินไปหรือ
                    ผิดปกติ
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (H) หากการเดิมพันถูกชำระผลอย่างไม่ถูกต้องเนื่องจากข้อผิดพลาด (จาก
                มนุษย์หรืออื่น ๆ) หรือความล้มเหลวของระบบ การชำระผลจะถือเป็นโมฆะและ
                จะถูกยกเลิก หากผู้ใช้ปลายทางมีเงินในบัญชีไม่เพียงพอที่จะดำเนินการนี้
                ผู้ใช้ปลายทางจะต้องคืนเงินจำนวนที่จำเป็นให้แก่ผู้ให้บริการ
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. มวยสากล</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>2.1</div>
              <div className="pl-3">
                เพื่อวัตถุประสงค์ในการเดิมพัน การตัดสิทธิ์นักมวยในระหว่างการแข่งขัน
                จะถูกนับเป็นการน็อกเอาท์โดยคู่ต่อสู้ของเขา
              </div>
            </li>
            <li className="flex pt-2">
              <div>2.2</div>
              <div className="pl-3">
                หากนักมวยไม่สามารถออกมาเมื่อระฆังเริ่มยกดังขึ้น หรือถูกตัดสิทธิ์
                ระหว่างยก คู่ต่อสู้ของเขาจะถือว่าเป็นผู้ชนะในยกก่อนหน้า
              </div>
            </li>
            <li className="flex pt-2">
              <div>2.3</div>
              <div className="pl-3">นี่คือการเดิมพันที่เปิดให้สำหรับมวยสากล:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">(I) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
                  <li className="pt-2 pl-3">
                    (II) คู่/คี่
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันคู่/คี่เกี่ยวข้องกับยกที่ประกาศผู้ชนะในการ
                        แข่งขัน (ไม่ว่าจะเป็นจำนวนคู่หรือคี่)
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) สูง/ต่ำ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันสูง/ต่ำเกี่ยวข้องกับยกที่ประกาศผู้ชนะในการ
                        แข่งขัน (ซึ่งได้ผลสูงหรือต่ำกว่ายกเป้าหมายที่ผู้ให้บริการ
                        กำหนด) สำหรับการแข่งขัน
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">3. เบสบอล</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>3.1</div>
              <div className="pl-3">
                การเดิมพันเบสบอลทั้งหมดเปิดให้บนพื้นฐานที่ผู้ขว้าง (pitcher) ทั้งสอง
                คนที่ระบุไว้ลงเริ่มเกม ผู้ขว้างทั้งสองคนต้องเริ่มเกมและขว้างลูกอย่าง
                น้อยหนึ่งลูกเพื่อให้การเดิมพันมีผล หากผู้ขว้างคนใดคนหนึ่งไม่สามารถ
                เริ่มเกมได้ด้วยเหตุผลใดก็ตาม การเดิมพันทั้งหมดที่วางสำหรับเหตุการณ์
                นั้นจะเป็นโมฆะและจะคืนเงินที่อัตราต่อรอง 1.00
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.2</div>
              <div className="pl-3">
                ในกรณีที่เราไม่ได้ระบุชื่อผู้ขว้างไว้ข้างทีม การเดิมพันที่รับบนทีม
                นั้นจะยังคงมีผลไม่ว่าผู้ขว้างที่เริ่มเกมจะเป็นใคร
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.3</div>
              <div className="pl-3">
                ผลของเกมจะอ้างอิงจากผลอย่างเป็นทางการ รวมอินนิงพิเศษ (หากมี) เมื่อ
                สิ้นสุดเกม
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.4</div>
              <div className="pl-3">
                กฎเบสบอลสากล: เกมจะจบก่อนกำหนดหากทีมหนึ่งนำอีกทีมด้วย 10 รันขึ้นไป
                หลังจากทีมตรงข้ามตีไปแล้วอย่างน้อย 7 อินนิง หรือหากทีมหนึ่งนำด้วย
                15 รันขึ้นไปหลังจากทีมตรงข้ามตีไปแล้วอย่างน้อย 5 อินนิง ในเหตุการณ์
                ดังกล่าว การเดิมพันทั้งหมดถือว่ามีผล
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.5</div>
              <div className="pl-3">
                กฎเบสบอลญี่ปุ่น: หากการแข่งขันถูกประกาศเสมอหลังจาก 12 อินนิง การ
                เดิมพันทั้งหมดถือว่ามีผล กฎเบสบอลญี่ปุ่นใช้กับลีกเบสบอลญี่ปุ่นเท่านั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>3.6</div>
              <div className="pl-3">นี่คือการเดิมพันที่เปิดให้สำหรับเบสบอล:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap)
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) สำหรับการเดิมพันอัตราต่อรองแบบเอเชียนเต็มเวลา การเดิมพัน
                        ทั้งหมดจะเป็นโมฆะหากเล่นน้อยกว่า 9 อินนิง ยกเว้นในกรณีที่ทีม
                        เหย้านำหลังจาก 8½ อินนิงเมื่อเกมจบก่อนกำหนด
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) การเดิมพันมันนี่ไลน์
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันทั้งหมดจะเป็นโมฆะหากเล่นน้อยกว่า 5 อินนิง
                        ยกเว้นในกรณีที่ทีมเหย้านำหลังจาก 4½ อินนิงเมื่อเกมจบก่อนกำหนด
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) เอาท์ไรท์ (Outright)</li>
                  <li className="pt-2 pl-3">
                    (IV) สูง/ต่ำ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) สำหรับการเดิมพันสูง/ต่ำเต็มเวลา การเดิมพันทั้งหมดจะเป็น
                        โมฆะหากเล่นน้อยกว่า 9 อินนิง ยกเว้นในกรณีที่ทีมเหย้านำหลังจาก
                        8½ อินนิงเมื่อเกมจบก่อนกำหนด
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) การเดิมพันรายช่วง
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพัน 5 อินนิงแรก (การเดิมพัน F5)
                      </li>
                      <li className="pt-2 pl-3">
                        (B) การเดิมพันทั้งหมดจะตัดสินบนพื้นฐานของสกอร์เมื่อจบ 5
                        อินนิงแรก หากเกมเล่นไม่ถึงห้าอินนิงเต็ม การเดิมพัน 5 อินนิง
                        แรกทั้งหมดจะถูกยกเลิก กฎเกี่ยวกับการเดิมพันอัตราต่อรองแบบ
                        เอเชียนเต็มเวลาและการเดิมพันสูง/ต่ำเต็มเวลาไม่ใช้กับการ
                        เดิมพัน 5 อินนิงแรก
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันแบบ In Running ("Live")
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap)
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันทั้งหมดจะเป็นโมฆะหากเล่นน้อยกว่า 9 อินนิง
                        ยกเว้นในกรณีที่ทีมเหย้านำหลังจาก 8½ อินนิงเมื่อเกมจบก่อนกำหนด
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) สูง/ต่ำ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันทั้งหมดจะเป็นโมฆะหากเล่นน้อยกว่า 9 อินนิง
                        ยกเว้นในกรณีที่ทีมเหย้านำหลังจาก 8½ อินนิงเมื่อเกมจบก่อนกำหนด
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) ระบบการให้คะแนน
                <div className="pt-1">ใช้ Type A Scoring</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. คริกเก็ต</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>4.1</div>
              <div className="pl-3">
                การเดิมพันการแข่งขันทั้งหมดจะตัดสินตามกฎการแข่งขันอย่างเป็นทางการ
                ในกรณีที่การแข่งขันได้รับผลกระทบจากสภาพอากาศไม่เอื้ออำนวย การเดิมพัน
                จะตัดสินตามผลการแข่งขันอย่างเป็นทางการ หากไม่มีผลการแข่งขันอย่างเป็น
                ทางการ การเดิมพันทั้งหมดจะเป็นโมฆะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.2</div>
              <div className="pl-3">
                กฎ dead heat ของคริกเก็ตคือกรณีที่มีผู้เข้าแข่งขัน/ทีมอย่างน้อยสอง
                รายถูกประกาศเป็นผู้ชนะ (dead heat) จำนวนตำแหน่งจ่ายเงินที่เหลือ
                หลังจากผู้ชนะที่ชัดเจนได้รับการชำระผลแล้ว จะถูกหารด้วยจำนวนผู้เข้า
                แข่งขัน/ทีมที่แบ่งตำแหน่งเหล่านั้น อัตราต่อรองสำหรับการเลือกจะถูก
                คูณด้วยค่าที่ได้
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.3</div>
              <div className="pl-3">
                ในกรณีที่เสมอ หากกฎเหตุการณ์กีฬาอย่างเป็นทางการไม่ตัดสินผู้ชนะ กฎ
                dead heat ของคริกเก็ตจะถูกนำมาใช้
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.4</div>
              <div className="pl-3">
                เว้นแต่จะระบุไว้เป็นอย่างอื่น ในเหตุการณ์กีฬาที่ bowl off หรือ super
                over เป็นตัวตัดสินผู้ชนะ การเดิมพันจะตัดสินตามผลการแข่งขันอย่างเป็น
                ทางการ
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.5</div>
              <div className="pl-3">
                หากการแข่งขันถูกยกเลิกเนื่องจากปัจจัยภายนอก การเดิมพันจะเป็นโมฆะ
                เว้นแต่มีการประกาศผู้ชนะตามกฎเหตุการณ์กีฬาอย่างเป็นทางการ
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.6</div>
              <div className="pl-3">
                หากการแข่งขันถูกยกเลิก การเดิมพันทั้งหมดจะเป็นโมฆะหากไม่มีการเล่นใหม่
                หรือเริ่มใหม่ภายใน 36 ชั่วโมงนับจากเวลาเริ่มต้นที่ประกาศไว้
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.7</div>
              <div className="pl-3">
                สำหรับการแข่งขัน first-class การเดิมพันจะเป็นโมฆะหากมีการโยนน้อยกว่า
                200 โอเวอร์ เว้นแต่สามารถชำระผลการเดิมพันใด ๆ ได้เนื่องจากผลของการ
                เดิมพันได้ถูกตัดสินแล้ว
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.8</div>
              <div className="pl-3">
                ในการแข่งขัน limited overs การเดิมพันจะเป็นโมฆะหากไม่สามารถเล่นได้
                อย่างน้อย 80% ของโอเวอร์ที่กำหนดในอินนิงใดอินนิงหนึ่งเนื่องจากปัจจัย
                ภายนอก รวมถึงแต่ไม่จำกัดเพียงสภาพอากาศไม่ดี เว้นแต่สามารถชำระผลการ
                เดิมพันใด ๆ ได้เนื่องจากผลของการเดิมพันได้ถูกตัดสินก่อนการลดจำนวน
              </div>
            </li>
            <li className="flex pt-2">
              <div>4.9</div>
              <div className="pl-3">
                นี่คือการเดิมพันที่เปิดให้สำหรับคริกเก็ตทั้งแบบไม่ใช่สดและแบบ In
                Running ("Live"):
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันการแข่งขัน ทีม และผู้เล่น
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) 1X2
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) สำหรับการแข่งขัน first-class หากผลอย่างเป็นทางการเสมอ
                        การเดิมพันจะตัดสินตามกฎ dead heat ของคริกเก็ตระหว่างทั้งสอง
                        ทีม การเดิมพันบนผลเสมอจะถูกตัดสินเป็นแพ้
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(II) Boundary ในโอเวอร์</li>
                  <li className="pt-2 pl-3">
                    (III) ผู้ชนะการโยนเหรียญ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) หากไม่มีการโยนเหรียญ การเดิมพันทั้งหมดจะเป็นโมฆะ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(IV) วิธีการ Dismissal</li>
                  <li className="pt-2 pl-3">(V) Dismissal ต่อโอเวอร์ / อินนิง</li>
                  <li className="pt-2 pl-3">(VI) ดับเบิลแชนซ์</li>
                  <li className="pt-2 pl-3">
                    (VII) Draw No Bet
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) สำหรับการแข่งขัน first-class ผลเสมอจะตัดสินตามกฎ dead
                        heat ของคริกเก็ต
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(VIII) สกอร์รายบุคคลสูงสุด</li>
                  <li className="pt-2 pl-3">
                    (IX) Opening Partnership สูงสุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันทั้งหมดจะอ้างอิงจากรันใน Opening Partnership
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (X) ผู้เล่นยอดเยี่ยมประจำแมตช์
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันจะตัดสินจากผู้เล่นยอดเยี่ยมประจำแมตช์ที่ประกาศ
                        อย่างเป็นทางการ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) หากไม่มีการประกาศผู้เล่นยอดเยี่ยมประจำแมตช์อย่างเป็น
                        ทางการ การเดิมพันทั้งหมดจะเป็นโมฆะ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XI) Match Ducks / Total Ducks
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) duck คือการที่นักตี (batsman) ถูก dismiss โดยทำได้ศูนย์
                        รัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) เพื่อวัตถุประสงค์ในการชำระผล นักตีที่ retired hurt จะไม่
                        นับเป็น dismissal
                      </li>
                      <li className="pt-2 pl-3">
                        (C) ducks ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XII) Match Extras / Total Extras
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) ลูก wide ทั้งหมด no balls, byes, leg byes และ penalty
                        runs ในการแข่งขันนับเข้าผลสุดท้าย หากมีรันจากไม้ตีรวมถึง
                        extras จากลูกเดียวกัน รันจากไม้ตีจะไม่นับเข้าผลรวมสุดท้าย
                      </li>
                      <li className="pt-2 pl-3">
                        (B) extras ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIII) Match Fours / Total Fours
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เฉพาะ fours ที่ทำได้จากไม้ตี (จากลูกใด ๆ ไม่ว่าถูก
                        กติกาหรือไม่) เท่านั้นที่จะนับเข้า total fours การ overthrow
                        all run fours และ extras ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) fours ที่ทำได้ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIV) Match Run Outs / Total Run Outs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) run outs ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XV) Match Sixes / Total Sixes
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เฉพาะ sixes ที่ทำได้จากไม้ตี (จากลูกใด ๆ ไม่ว่าถูกกติกา
                        หรือไม่) เท่านั้นที่จะนับเข้า total sixes การ overthrow และ
                        extras ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) sixes ที่ทำได้ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVI) Match Wides / Total Wides
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) รันใด ๆ ที่เกิดจากลูก wide ยกเว้น penalty runs จะนับเข้า
                        ผลรวมสุดท้าย
                      </li>
                      <li className="pt-2 pl-3">
                        (B) wides ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVII) Match Wickets / Total Wickets
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) รับการเดิมพันบนจำนวน wickets ทั้งหมดที่จะเสียในการแข่งขัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) เพื่อวัตถุประสงค์ในการชำระผล นักตีที่ retires hurt จะไม่
                        นับเป็น wicket
                      </li>
                      <li className="pt-2 pl-3">
                        (C) wickets ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XVIII) โอเวอร์สูงสุดในแมตช์
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) ทายรันที่จะทำได้ในโอเวอร์ที่ทำสกอร์สูงสุดในการแข่งขัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) รันทั้งหมด รวมถึง extras นับเข้าการชำผล
                      </li>
                      <li className="pt-2 pl-3">
                        (C) super overs ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XIX) จับลูกมากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนทีมที่จะจับลูกได้มากที่สุด รวมถึงการจับลูกโดย
                        fielders และ wicket keeper
                      </li>
                      <li className="pt-2 pl-3">
                        (B) สำหรับการแข่งขัน first-class จะนับเฉพาะการจับลูกในอินนิง
                        แรกเท่านั้น
                      </li>
                      <li className="pt-2 pl-3">
                        (C) การจับลูกที่ทำได้ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XX) Extras มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) ลูก wide ทั้งหมด no balls, byes, leg byes และ penalty
                        runs ในการแข่งขันนับเข้าผลสุดท้าย หากมีรันจากไม้ตีรวมถึง
                        extras จากลูกเดียวกัน รันจากไม้ตีจะไม่นับเข้าผลรวมสุดท้าย
                      </li>
                      <li className="pt-2 pl-3">
                        (B) extras ใน super over ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class จะนับเฉพาะ extras ในอินนิง
                        แรกเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXI) Fours มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เฉพาะ fours ที่ทำได้จากไม้ตี (จากลูกใด ๆ ไม่ว่าถูกกติกา
                        หรือไม่) เท่านั้นที่จะนับเข้า total fours การ overthrow all
                        run fours และ extras ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) fours ที่ทำได้ใน super over ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class จะนับเฉพาะ fours ในอินนิง
                        แรกเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXII) Keeper Catches มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) หากทีมเปลี่ยน wicket keeper กลางอินนิง การจับลูกที่ทำได้
                        โดยตัวแทนจะนับเข้าการชำระผล
                      </li>
                      <li className="pt-2 pl-3">
                        (B) การจับลูกที่ทำได้ใน super over ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class จะนับเฉพาะการจับลูกในอินนิง
                        แรกเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIII) Sixes มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เฉพาะ sixes ที่ทำได้จากไม้ตี (จากลูกใด ๆ ไม่ว่าถูกกติกา
                        หรือไม่) เท่านั้นที่จะนับเข้า total sixes การ overthrow และ
                        extras ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) sixes ที่ทำได้ใน super over ไม่นับ
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class จะนับเฉพาะ sixes ในอินนิง
                        แรกเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIV) Stumpings มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) สำหรับการแข่งขัน first-class จะนับเฉพาะ stumpings ใน
                        อินนิงแรกเท่านั้น
                      </li>
                      <li className="pt-2 pl-3">
                        (B) stumpings ที่ทำได้ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(XXV) เอาท์ไรท์ (Outright)</li>
                  <li className="pt-2 pl-3">(XXVI) สูง / ต่ำ</li>
                  <li className="pt-2 pl-3">
                    (XXVII) ผู้เล่นหัวต่อหัว
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) หากผู้เล่นไม่ได้ตีหรือโยน แต่อยู่ในผู้เล่นสิบเอ็ดคนแรก
                        การเดิมพันทั้งหมดจะยังคงมีผล หากผู้เล่นไม่ได้อยู่ในผู้เล่น
                        สิบเอ็ดคนแรก การเดิมพันจะเป็นโมฆะ
                      </li>
                      <li className="pt-2 pl-3">
                        (B) ผลจะถือว่าถูกตัดสินหากเส้นที่วางเดิมพันถูกข้ามไปแล้ว
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class จะนับเฉพาะอินนิงแรกเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXVIII) ผลงานผู้เล่น
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) ตลาดเหล่านี้ใช้ระบบการให้คะแนนแบบแต้มเพื่อตัดสินผลลัพธ์
                        เป็นคะแนนรวมโดย 1 แต้มต่อรัน 20 แต้มต่อ wicket 10 แต้มต่อการ
                        จับลูก และ 25 แต้มต่อ stumping
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXIX) Rabbit Runs
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนรันรวมที่ทำได้โดยนักตีหมายเลข 11 ในการแข่งขัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) นักตีหมายเลข 11 จะถือเป็นผู้เล่นคนสุดท้ายที่ออกมาตีใน
                        อินนิง โดยไม่คำนึงถึงลำดับที่ระบุไว้ก่อนหน้า หากมีผู้เล่นตี
                        มากกว่า 11 คน การเดิมพันทั้งหมดบนตลาดนั้นจะเป็นโมฆะ
                      </li>
                      <li className="pt-2 pl-3">
                        (C) หากอินนิงจบลงโดยนักตีหมายเลข 11 ไม่ได้ออกมาที่ crease
                        นักตีนั้นจะถือว่าทำได้ศูนย์ (0)
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXX) รันในโอเวอร์แรก
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) โอเวอร์แรกต้องเล่นจบเพื่อให้การเดิมพันมีผล เว้นแต่สามารถ
                        ชำระผลการเดิมพันใด ๆ ได้เนื่องจากผลของการเดิมพันได้ถูกตัดสิน
                        แล้ว
                      </li>
                      <li className="pt-2 pl-3">
                        (B) หากอินนิงจบลงในระหว่างโอเวอร์ โอเวอร์นั้นจะถือว่าจบแล้ว
                        เว้นแต่อินนิงจบลงเนื่องจากปัจจัยภายนอก รวมถึงแต่ไม่จำกัดเพียง
                        สภาพอากาศไม่ดี ซึ่งในกรณีนั้นการเดิมพันทั้งหมดจะเป็นโมฆะ
                        เว้นแต่สามารถชำระผลการเดิมพันใด ๆ ได้เนื่องจากผลของการเดิมพัน
                        ได้ถูกตัดสินแล้ว
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class ตลาดนี้หมายถึงเฉพาะอินนิง
                        แรกของแต่ละทีมเท่านั้น
                      </li>
                      <li className="pt-2 pl-3">
                        (D) extras และ penalty runs ในโอเวอร์นั้นจะนับเข้าการชำระผล
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXI) รันใน Opening Partnership
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) หากทีมที่ตีถึงจุดสิ้นสุดของโอเวอร์ที่กำหนด หรือถึงรัน
                        เป้าหมาย หรือ declares ก่อนที่ wicket แรกจะเสีย ผลจะเป็นรัน
                        รวมที่สะสมได้
                      </li>
                      <li className="pt-2 pl-3">
                        (B) ผลจะถือว่าถูกตัดสินหากเส้นที่วางเดิมพันถูกข้ามไปแล้ว หรือ
                        หากมี wicket เสียไป
                      </li>
                      <li className="pt-2 pl-3">
                        (C) เพื่อวัตถุประสงค์ในการชำระผล นักตีที่ retiring hurt จะไม่
                        นับเป็น wicket
                      </li>
                      <li className="pt-2 pl-3">
                        (D) สำหรับการแข่งขัน first-class ตลาดนี้หมายถึงเฉพาะอินนิง
                        แรกของแต่ละทีมเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXII) รันในกลุ่มของโอเวอร์
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) หากไม่ได้เล่นโอเวอร์ตามจำนวนที่กำหนดจนครบ การเดิมพันจะ
                        เป็นโมฆะ เว้นแต่ทีม all out หรือ declares หรือถึงรันเป้าหมาย
                        หรือสามารถชำระผลการเดิมพันใด ๆ ได้เนื่องจากผลของการเดิมพันได้
                        ถูกตัดสินแล้วก่อนการลดจำนวน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) สำหรับการแข่งขัน first-class ตลาดนี้หมายถึงเฉพาะอินนิง
                        แรกเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIII) รันจากลูกแรก
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เพื่อวัตถุประสงค์ในการชำระผล ลูกที่ผิดกติกาทั้งหมดนับเป็น
                        ลูกที่โยน หากโอเวอร์เริ่มด้วย wide ลูกแรกจะถูกชำระผลเป็น 1
                        และแม้ว่าจะยังไม่มีการโยนลูกที่ถูกกติกา ลูกถัดไปจะถือเป็นลูก
                        ที่ 2 สำหรับโอเวอร์นั้น
                      </li>
                      <li className="pt-2 pl-3">
                        (B) หากลูกนำไปสู่ free hit รันที่ทำได้จากลูกเพิ่มเติมจะไม่นับ
                        รันทั้งหมด ไม่ว่าจะจากไม้ตีหรือไม่ จะถูกรวมไว้ ตัวอย่างเช่น
                        wide ที่มีสามรันเพิ่มเติมเท่ากับ 4 รันรวมจากลูกนั้น
                      </li>
                      <li className="pt-2 pl-3">
                        (C) สำหรับการแข่งขัน first-class ตลาดนี้หมายถึงเฉพาะอินนิง
                        แรกของแต่ละทีมเท่านั้น
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIV) ทีมที่จบด้วย Boundary
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXV) ทีมที่มีสกอร์สูงสุดในแต่ละ Dismissal
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVI) ทีมที่มีโอเวอร์ที่ทำสกอร์สูงสุด
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVII) แมตช์เสมอ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) สำหรับการแข่งขัน first-class ผลเสมอคือเมื่อฝ่ายที่ตีใน
                        อินนิงที่สี่ถูก bowled out ขณะที่สกอร์เท่ากัน
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXVIII) นักตียอดเยี่ยม / ทีมที่มีนักตียอดเยี่ยม
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) ทายนักตีที่มีสกอร์รายบุคคลสูงสุดในการแข่งขัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) ในการแข่งขัน limited overs การเดิมพันจะเป็นโมฆะหากไม่
                        สามารถเล่นได้อย่างน้อย 50% ของโอเวอร์ที่กำหนดให้โยนในแต่ละ
                        อินนิง ณ เวลาที่วางเดิมพัน เนื่องจากปัจจัยภายนอก รวมถึงแต่ไม่
                        จำกัดเพียงสภาพอากาศไม่ดี
                      </li>
                      <li className="pt-2 pl-3">
                        (C) การเดิมพันนักตียอดเยี่ยมสำหรับการแข่งขัน first-class ใช้
                        เฉพาะอินนิงแรกของแต่ละทีมเท่านั้น และจะเป็นโมฆะหากมีการโยน
                        น้อยกว่า 200 โอเวอร์ เว้นแต่อินนิงแรกทั้งสองได้เล่นจบแล้ว
                      </li>
                      <li className="pt-2 pl-3">
                        (D) หากนักตีถูกระบุชื่อตอนโยนเหรียญ แต่ภายหลังถูกถอดออกในฐานะ
                        ตัวสำรอง นักตีนั้นจะยังถูกนับ เช่นเดียวกับนักตีที่มาแทน
                      </li>
                      <li className="pt-2 pl-3">
                        (E) เมื่อนักตีตั้งแต่สองคนขึ้นไปทำรันได้เท่ากัน กฎ dead heat
                        ของคริกเก็ตจะถูกนำมาใช้
                      </li>
                      <li className="pt-2 pl-3">
                        (F) รันที่ทำได้ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (XXXIX) นักโยนยอดเยี่ยม / ทีมที่มีนักโยนยอดเยี่ยม
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) ทายนักโยนที่ได้ wickets มากที่สุดในการแข่งขัน
                      </li>
                      <li className="pt-2 pl-3">
                        (B) ในการแข่งขัน limited overs การเดิมพันจะเป็นโมฆะหากไม่
                        สามารถเล่นได้อย่างน้อย 50% ของโอเวอร์ที่กำหนดให้โยนในแต่ละ
                        อินนิง ณ เวลาที่วางเดิมพัน เนื่องจากปัจจัยภายนอก รวมถึงแต่ไม่
                        จำกัดเพียงสภาพอากาศไม่ดี
                      </li>
                      <li className="pt-2 pl-3">
                        (C) การเดิมพันนักโยนยอดเยี่ยมสำหรับการแข่งขัน first-class ใช้
                        เฉพาะอินนิงแรกของแต่ละทีมเท่านั้น และจะเป็นโมฆะหากมีการโยน
                        น้อยกว่า 200 โอเวอร์ เว้นแต่อินนิงแรกทั้งสองได้เล่นจบแล้ว
                      </li>
                      <li className="pt-2 pl-3">
                        (D) หากนักโยนถูกระบุชื่อตอนโยนเหรียญ แต่ภายหลังถูกถอดออกในฐานะ
                        ตัวสำรอง นักโยนนั้นจะยังถูกนับ เช่นเดียวกับนักโยนที่มาแทน
                      </li>
                      <li className="pt-2 pl-3">
                        (E) หากนักโยนตั้งแต่สองคนขึ้นไปได้ wickets เท่ากัน นักโยนที่
                        เสียรันน้อยที่สุดจะเป็นผู้ชนะ หากได้ wickets และเสียรันเท่า
                        กัน กฎ dead heat ของคริกเก็ตจะถูกนำมาใช้
                      </li>
                      <li className="pt-2 pl-3">
                        (F) wickets ที่ได้ใน super over ไม่นับ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(XL) Total ในแต่ละ Dismissal</li>
                  <li className="pt-2 pl-3">(XLI) Total Dismissals</li>
                  <li className="pt-2 pl-3">
                    (XLII) Total ในโอเวอร์ที่ทำสกอร์สูงสุด
                  </li>
                  <li className="pt-2 pl-3">
                    (XLIII) รันรวมต่อโอเวอร์ / อินนิง
                  </li>
                  <li className="pt-2 pl-3">
                    (XLIV) Wickets ในกลุ่มของโอเวอร์
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันหมายถึง wickets ที่จะเสียในโอเวอร์ตามจำนวนที่
                        กำหนด
                      </li>
                      <li className="pt-2 pl-3">
                        (B) หากไม่ได้เล่นโอเวอร์ตามจำนวนที่กำหนดจนครบ การเดิมพันจะ
                        เป็นโมฆะ เว้นแต่ทีม all out หรือ declares หรือถึงรันเป้าหมาย
                        หรือสามารถชำระผลการเดิมพันใด ๆ ได้เนื่องจากผลของการเดิมพันได้
                        ถูกตัดสินแล้ว
                      </li>
                      <li className="pt-2 pl-3">
                        (C) เพื่อวัตถุประสงค์ในการชำระผล หากนักตีถูก timed out หรือ
                        retired out wicket นั้นจะถือว่าเกิดขึ้นในลูกก่อนหน้า เพื่อ
                        วัตถุประสงค์ในการชำระผล นักตีที่ retires hurt จะไม่นับเป็น
                        dismissal
                      </li>
                      <li className="pt-2 pl-3">
                        (D) สำหรับการแข่งขัน first-class ตลาดนี้หมายถึงเฉพาะอินนิง
                        แรกของแต่ละทีมเท่านั้น
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>4.10</div>
              <div className="pl-3">
                ระบบการให้คะแนนที่ใช้กับการเดิมพันสำหรับคริกเก็ตคือ Type B Scoring
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">5. ฟุตบอล</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>5.1</div>
              <div className="pl-3">
                เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎการเดิมพันฟุตบอลเหล่านี้ การเดิมพัน
                ทั้งหมดจะตัดสินจากเวลาเล่นปกติ (รวมเวลาทดเจ็บที่ผู้ตัดสินเพิ่มเข้ามา)
                ไม่รวมช่วงต่อเวลาพิเศษและการยิงจุดโทษ
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.2</div>
              <div className="pl-3">
                ในกรณีที่การแข่งขันมีกำหนดเล่นนอกเหนือจากเวลาปกติ (เช่น ช่วงเวลา
                เล่นพิเศษในทัวร์นาเมนต์ต่าง ๆ หรือการแข่งขันกระชับมิตร) การเดิมพัน
                ทั้งหมดจะตัดสินจากสกอร์สุดท้ายเมื่อจบเวลาที่กำหนดนั้น
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.3</div>
              <div className="pl-3">
                เว้นแต่การแข่งขันที่ไม่ใช่เวลาปกติจะระบุไว้อย่างชัดเจนบนเว็บไซต์ก่อน
                การแข่งขันฟุตบอลทั้งหมด การเดิมพันที่รับบนการแข่งขันดังกล่าวจะถือเป็น
                โมฆะ
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.4</div>
              <div className="pl-3">
                หากสถานะหรือผลของการแข่งขันที่ประกาศบนเว็บไซต์อย่างเป็นทางการผิด
                อย่างชัดเจน หรือในกรณีที่การแข่งขันไม่เล่นจบภายในเวลาปกติ ผู้ให้
                บริการจะใช้ความพยายามอย่างดีที่สุดในการตัดสินสถานะและผลที่ถูกต้องของ
                การแข่งขัน ในกรณีใดก็ตามที่การแข่งขันไม่เล่นจบภายในเวลาปกติที่กำหนด
                [เวลาปกติหมายถึงเวลารวมที่กำหนดให้เล่นได้ รวมเวลาทดเจ็บที่เจ้าหน้าที่
                ระบุ] เกมจะถูกชำระผลโดยผู้ให้บริการว่าไม่สมบูรณ์ ในกรณีดังกล่าวจะมี
                การชำระผลเฉพาะตลาดที่ได้ถูกตัดสินอย่างไม่มีเงื่อนไขเท่านั้น สำหรับ
                ตลาดอื่น ๆ ทั้งหมด การเดิมพันจะเป็นโมฆะและคืนเงินเดิมพันให้ผู้เล่น
                ผู้ให้บริการจะชำระผลการแข่งขันดังกล่าวตามกฎเหล่านี้ และการตัดสินของ
                ผู้ให้บริการถือเป็นที่สิ้นสุด
              </div>
            </li>
            <li className="flex pt-2">
              <div>5.5</div>
              <div className="pl-3">
                นี่คือการเดิมพันที่เปิดให้สำหรับฟุตบอล การเดิมพันแบบ In Running
                ("Live") จะเปิดให้แยกต่างหากในส่วน "Live"
              </div>
            </li>
            <ol type="I">
              <li className="pt-2 pl-3">(I) 1X2</li>
              <li className="pt-2 pl-3">(II) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
              <li className="pt-2 pl-3">
                (III) Clean Sheet
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายว่าทีมจะรักษา clean sheet และไม่เสียประตูในการแข่งขันที่
                    กำหนดหรือไม่ (เช่น ทีม A ชนะทีม B 3-0 ทีม A ได้ "รักษา clean
                    sheet" เนื่องจากไม่เสียประตูใด ๆ)
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิก การเดิมพันทั้งหมดจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (IV) ผลสกอร์ที่ถูกต้อง - ครึ่งแรก &amp; เต็มเวลา
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) เพื่อชนะผลสกอร์ที่ถูกต้อง ทีมที่คุณเลือก (เหย้าหรือเยือน)
                    ต้องชนะด้วยผลหรือสกอร์ที่ถูกต้อง
                  </li>
                  <li className="pt-2 pl-3">
                    (B) เพื่อชนะผลสกอร์ที่ถูกต้อง UP-5 ทีมที่คุณเลือก (เหย้าหรือ
                    เยือน) ต้องชนะด้วยผลต่างประตู 5 ลูกขึ้นไป
                  </li>
                  <li className="pt-2 pl-3">
                    (C) เพื่อชนะ AOS หรือ "สกอร์อื่นใด" ทีมที่คุณเลือก (เหย้าหรือ
                    เยือน) ต้องชนะด้วยผลหรือสกอร์ที่ไม่ได้ระบุไว้ในตลาด
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (V) ดับเบิลแชนซ์
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) เดิมพัน 2 ใน 3 ผลลัพธ์ที่เป็นไปได้จาก 3 ตัวเลือกที่มี (เช่น
                    ทีมเหย้าชนะหรือเสมอ (1X), ทีมเยือนชนะหรือเสมอ (X2), ทีมเหย้าชนะ
                    หรือทีมเยือนชนะ (12))
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันจัดขึ้นในสนามกลาง การเดิมพันจะตัดสินตามสถานที่
                    การแข่งขัน (ทีมเหย้า/เยือน) ที่แสดงบนเว็บไซต์ของเรา
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(VI) การแข่งขันแฟนตาซี</li>
              <li className="pt-2 pl-3">
                (VII) เตะมุมแรก
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายทีมที่จะได้เตะมุมแรกในการแข่งขันที่กำหนดภายในเวลาเล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิกหลังจากได้เตะมุมแรกแล้ว การเดิมพัน
                    ทั้งหมดบนเตะมุมแรกจะยังคงมีผล
                  </li>
                  <li className="pt-2 pl-3">
                    (C) หากการแข่งขันถูกยกเลิกก่อนได้เตะมุมแรก การเดิมพันทั้งหมดบน
                    เตะมุมแรกจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (VIII) ประตูแรก / ประตูสุดท้าย / ไม่มีประตู
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายประตูแรก ประตูสุดท้าย หรือไม่มีประตูหลังจากเขี่ยลูกในการ
                    แข่งขันที่กำหนดภายในเวลาเล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) การทำเข้าประตูตัวเองนับให้ฝ่ายที่ได้รับเครดิตประตู (เช่น ทีม
                    A พบทีม B ทีม B ทำเข้าประตูตัวเองทำให้สกอร์เป็น 1-0 ประตูแรกจะ
                    มอบให้ทีม A)
                  </li>
                  <li className="pt-2 pl-3">
                    (C) หากการแข่งขันถูกยกเลิกหลังจากมีการทำประตู การเดิมพันทั้งหมด
                    บนประตูแรกและไม่มีประตูจะยังคงมีผล แต่การเดิมพันทั้งหมดบนประตู
                    สุดท้ายจะคืนเงินเดิมพัน
                  </li>
                  <li className="pt-2 pl-3">
                    (D) หากการแข่งขันถูกยกเลิกโดยไม่มีประตูใด ๆ การเดิมพันทั้งหมดบน
                    ประตูแรก ประตูสุดท้าย และไม่มีประตูจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (IX) ล้ำหน้าแรก / ล้ำหน้าสุดท้าย
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายทีมที่จะล้ำหน้าแรก/สุดท้ายในการแข่งขันที่กำหนดภายในเวลา
                    เล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิกหลังจากล้ำหน้าแรก การเดิมพันทั้งหมดบน
                    ล้ำหน้าแรกจะยังคงมีผล แต่การเดิมพันทั้งหมดบนล้ำหน้าสุดท้ายจะคืน
                    เงินเดิมพัน
                  </li>
                  <li className="pt-2 pl-3">
                    (C) หากการแข่งขันถูกยกเลิกก่อนมีการล้ำหน้าใด ๆ การเดิมพันทั้งหมด
                    บนล้ำหน้าแรก/สุดท้ายจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (X) การเปลี่ยนตัวแรก / สุดท้าย
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายว่าทีมใดในสองทีมจะเปลี่ยนตัวผู้เล่นแรก/สุดท้ายในการ
                    แข่งขันที่กำหนดภายในเวลาเล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) ในกรณีที่มีผู้เล่นมากกว่าสองคนถูกเปลี่ยนตัวพร้อมกัน หมายเลข
                    ผู้เล่นที่แสดงก่อนโดยกรรมการที่ 4 จะถือเป็นผลลัพธ์
                  </li>
                  <li className="pt-2 pl-3">
                    (C) หากการแข่งขันถูกยกเลิกหลังจากมีการเปลี่ยนตัวแรกแล้ว การ
                    เดิมพันทั้งหมดบนการเปลี่ยนตัวแรกจะยังคงมีผล แต่การเดิมพันทั้งหมด
                    บนการเปลี่ยนตัวสุดท้ายจะคืนเงินเดิมพัน
                  </li>
                  <li className="pt-2 pl-3">
                    (D) หากการแข่งขันถูกยกเลิกก่อนมีการเปลี่ยนตัวใด ๆ การเดิมพัน
                    ทั้งหมดบนการเปลี่ยนตัวแรก/สุดท้ายจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XI) ใบเหลืองแรก
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายทีมที่จะได้รับใบเหลืองแรกในการแข่งขันที่กำหนดภายในเวลา
                    เล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการลงโทษเป็นใบแดงตรง (professional foul) จะถือว่าเป็น
                    ใบแดงแต่ไม่ใช่ใบเหลือง
                  </li>
                  <li className="pt-2 pl-3">
                    (C) ในกรณีที่มีผู้เล่นตั้งแต่สองคนขึ้นไปได้รับการลงโทษจากเหตุการณ์
                    เดียวกัน ผู้เล่นที่ถูกผู้ตัดสินแสดงใบเหลืองก่อนจะถือเป็นผลลัพธ์
                  </li>
                  <li className="pt-2 pl-3">
                    (D) ใบเหลืองที่แสดงแก่ผู้ที่ไม่ใช่ผู้เล่น (เช่น ตัวสำรอง ผู้
                    จัดการ หรือโค้ช) ไม่นับ
                  </li>
                  <li className="pt-2 pl-3">
                    (E) หากการแข่งขันถูกยกเลิกหลังจากได้รับใบเหลืองแรกแล้ว การเดิมพัน
                    ทั้งหมดบนใบเหลืองแรกจะยังคงมีผล
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XII) ผู้ทำประตู
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายผู้ทำประตูในการแข่งขันที่กำหนด
                  </li>
                  <li className="pt-2 pl-3">
                    (B) การเดิมพันจะคืนเงินเดิมพันหากผู้เล่นที่เลือกไม่ได้ลงเล่นใน
                    การแข่งขัน
                  </li>
                  <li className="pt-2 pl-3">
                    (C) การเดิมพันยังคงมีผลหากผู้เล่นที่เลือกได้ลงสนามในช่วงเวลาใด
                    ก็ตามระหว่างเวลาเล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (D) การทำเข้าประตูตัวเองและประตูที่ทำได้ในระหว่างการยิงจุดโทษ
                    ไม่นับ
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XIII) เตะมุมสุดท้าย
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ทายทีมที่จะได้เตะมุมสุดท้ายในการแข่งขันที่กำหนดภายในเวลาเล่น
                    ปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิกภายในเวลาเล่นปกติ การเดิมพันทั้งหมดบน
                    เตะมุมสุดท้ายจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(XIV) คู่/คี่</li>
              <li className="pt-2 pl-3">
                (XV) เอาท์ไรท์ (Outright)
                <ol type="A">
                  <li className="pt-2 pl-3">(A) ผู้ทำประตูสูงสุด</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">(XVI) สูง/ต่ำ</li>
              <li className="pt-2 pl-3">
                (XVII) การยิงจุดโทษ
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) แฮนดิแคป
                    <ol type="1">
                      <li className="pt-2 pl-3">
                        (1) ผลแฮนดิแคปการยิงจุดโทษรวม sudden death
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (B) สูง/ต่ำ
                    <ol type="1">
                      <li className="pt-2 pl-3">
                        (1) ผลสูง/ต่ำการยิงจุดโทษไม่รวม sudden death และอ้างอิงจาก
                        การยิงจุดโทษ 5 ครั้งต่อทีม
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XVIII) จุดโทษที่ถูกยิง
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) การทายจุดโทษที่ได้รับและถูกยิงในการแข่งขันที่กำหนดภายในเวลา
                    เล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิกหลังจากจุดโทษได้รับและถูกยิงแล้ว การ
                    เดิมพันทั้งหมดจะยังคงมีผล
                  </li>
                  <li className="pt-2 pl-3">
                    (C) หากการแข่งขันถูกยกเลิกก่อนจุดโทษได้รับและถูกยิง การเดิมพัน
                    ทั้งหมดจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XIX) การเดิมพันรายช่วง
                <div className="pt-1">เหตุการณ์ทุก 10 และ 15 นาที</div>
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) การเดิมพันเหตุการณ์ทุก 10 และ 15 นาทีตัดสินจากจำนวนรวมของ
                    การกระทำ (เช่น ประตู เตะมุม หรือใบเตือน) ในการแข่งขันภายในช่วง
                    บล็อก 10 หรือ 15 นาทีในระหว่างเกม (เช่น 00:00-15:00;
                    15:01-30:00)
                  </li>
                  <li className="pt-2 pl-3">
                    (B) เวลาของการกระทำจะตัดสินโดยอ้างอิงเวลาการแข่งขันอย่างเป็น
                    ทางการ
                  </li>
                  <li className="pt-2 pl-3">
                    (C) การเดิมพันที่รอดำเนินการเกินช่วงเวลาเฉพาะสำหรับการเดิมพันจะ
                    ถูกปฏิเสธและคืนเงินเดิมพัน
                  </li>
                  <li className="pt-2 pl-3">
                    (D) การกระทำที่ทำซ้ำจะไม่ถูกนับรวม
                  </li>
                  <li className="pt-2 pl-3">
                    (E) ให้นำกฎจำนวนใบเตือนรวม (กฎการเดิมพันเฉพาะกีฬา xxi) มาใช้
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XX) ประตูรวม
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) การเดิมพันประตูรวมเกี่ยวข้องกับการทายผลรวมสะสมของประตูหรือ
                    แต้มที่ทำได้ในการแข่งขันที่วางเดิมพันไว้
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXI) จำนวนใบเตือนรวม
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) เฉพาะ fours ที่ทำได้จากไม้ตี (จากลูกใด ๆ ไม่ว่าถูกกติกาหรือ
                    ไม่) เท่านั้นที่จะนับเข้า total fours การ overthrow all run fours
                    และ extras ไม่นับ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) fours ที่ทำได้ใน super over ไม่นับ
                  </li>
                  <li className="pt-2 pl-3">
                    (C) สำหรับการแข่งขัน first-class จะนับเฉพาะ fours ในอินนิงแรก
                    เท่านั้น
                    <ol type="i">
                      <li className="pt-2 pl-3">(i) ใบเหลือง 1 ใบ = 1 แต้ม</li>
                      <li className="pt-2 pl-3">(ii) ใบแดง 1 ใบ = 2 แต้ม</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (D) จำนวนแต้มสูงสุดต่อผู้เล่นคือ 3 แต้ม; 1 แต้มสำหรับใบเหลืองใบ
                    แรกและ 2 แต้มสำหรับใบแดง ใบเหลืองใบที่ 2 จะไม่ถูกนับ
                  </li>
                  <li className="pt-2 pl-3">
                    (E) หากการแข่งขันถูกยกเลิกภายในเวลาเล่นปกติ การเดิมพันทั้งหมดบน
                    ใบเตือนรวมจะคืนเงินเดิมพัน
                  </li>
                  <li className="pt-2 pl-3">
                    (F) ผลใบเตือนรวมสำหรับครึ่งแรกจะถูกตัดสินเมื่อเจ้าหน้าที่การ
                    แข่งขันเป่านกหวีดจบครึ่งแรก ใบเตือนใด ๆ ที่เกิดขึ้นระหว่างเวลาที่
                    เจ้าหน้าที่การแข่งขันเป่านกหวีดจบครึ่งแรกและการเริ่มครึ่งหลังจะ
                    ถูกสะสมเข้าผลใบเตือนรวมสำหรับเต็มเวลา
                  </li>
                  <li className="pt-2 pl-3">
                    (G) ผลใบเตือนรวมสำหรับเต็มเวลาจะถูกตัดสินจากจำนวนใบเตือนที่สะสม
                    จนกระทั่งเป่านกหวีดจบเต็มเวลา ใบเตือนใด ๆ ที่เกิดขึ้นหลังจากเป่า
                    นกหวีดจบเต็มเวลาแล้วจะไม่ถูกนำมาพิจารณา
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXII) จำนวนเตะมุมรวม
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ผลจำนวนเตะมุมตัดสินจากจำนวนเตะมุมรวมที่ได้รับให้แก่ทีมเหย้า
                    ทีมเยือน หรือทั้งทีมเหย้าและทีมเยือนในการแข่งขันที่กำหนด (รวม
                    แต้มต่อ หากมี)
                  </li>
                  <li className="pt-2 pl-3">
                    (B) เตะมุมที่เตะใหม่นับเป็นหนึ่ง
                  </li>
                  <li className="pt-2 pl-3">
                    (C) เตะมุมที่ได้รับแต่ไม่ได้เตะไม่นับ
                  </li>
                  <li className="pt-2 pl-3">
                    (D) การเดิมพันเตะมุมรวมทั้งหมดบนอัตราต่อรองแบบเอเชียน (Asian
                    Handicap) และสูง/ต่ำ ที่อยู่ในโหมดรอดำเนินการ จะถูกยกเลิกหากเกิด
                    เหตุการณ์ใดเหตุการณ์หนึ่งต่อไปนี้:
                    <ol type="1">
                      <li className="pt-2 pl-3">(1) มีการทำประตู; หรือ</li>
                      <li className="pt-2 pl-3">(2) มีผู้เล่นถูกไล่ออก</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXIII) จำนวนการเปลี่ยนตัวรวม
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ผลจำนวนการเปลี่ยนตัวรวมตัดสินจากจำนวนการเปลี่ยนตัวรวมของทีม
                    เหย้า/เยือนที่ทำภายในการแข่งขันที่กำหนด
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิกภายในเวลาเล่นปกติ การเดิมพันทั้งหมดบน
                    จำนวนการเปลี่ยนตัวรวมจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXIV) จำนวนล้ำหน้ารวม
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) การชำระผลการเดิมพันล้ำหน้ารวมจะทำในการแข่งขันที่กำหนดภายใน
                    เวลาเล่นปกติ
                  </li>
                  <li className="pt-2 pl-3">
                    (B) หากการแข่งขันถูกยกเลิกภายในเวลาเล่นปกติ การเดิมพันทั้งหมดบน
                    ล้ำหน้ารวมจะคืนเงินเดิมพัน
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXV) ผลรวมทีมเหย้า vs. ผลรวมทีมเยือน
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ผลรวมทีมเหย้า vs. ผลรวมทีมเยือนตัดสินจากจำนวนประตูรวมที่ทำ
                    ได้โดยทีมเหย้าเทียบกับจำนวนประตูรวมที่ทำได้โดยทีมเยือนในลีกที่
                    เปิดให้เดิมพัน
                  </li>
                  <li className="pt-2 pl-3">
                    (B) ทีมเหย้าหมายถึงทีมแรกที่ระบุบนเว็บไซต์ของเรา ทีมเยือนหมายถึง
                    ทีมที่สองที่ระบุบนเว็บไซต์ของเรา
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXVI) ประตูรวมของทีม
                <ol type="A">
                  <li className="pt-2 pl-3">
                    (A) ประตูรวมของทีมตัดสินจากจำนวนประตูรวมที่ทำได้โดยทีมในการ
                    แข่งขัน เช่น ประตูรวม West Ham - (สูง) หรือประตูรวม West Ham
                    (ต่ำ)
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (XXVII) การกระทำถัดไป (ประตู เตะมุม หรือใบเตือน)
                <div className="pt-1">
                  การเดิมพันนี้กำหนดให้คุณทายว่าทีมใดจะได้รับการกระทำถัดไปในการ
                  แข่งขัน (ประตู เตะมุม หรือใบเตือน) หากไม่มีการกระทำใด ๆ ที่ได้รับ
                  การเดิมพันทั้งหมดจะคืนเงินเดิมพัน
                </div>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>5.6</div>
              <div className="pl-3">
                Type A Scoring ใช้กับผลิตภัณฑ์ต่อไปนี้ที่เปิดให้เดิมพันสด:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) 1X2</li>
              <li className="pt-2 pl-3">(B) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
              <li className="pt-2 pl-3">(C) คู่/คี่</li>
              <li className="pt-2 pl-3">(D) สูง/ต่ำ</li>
              <li className="pt-2 pl-3">(E) จำนวนเตะมุมรวม</li>
              <li className="pt-2 pl-3">(F) จำนวนใบเตือนรวม</li>
            </ol>
            <li className="flex pt-2">
              <div>5.7</div>
              <div className="pl-3">
                Type B Scoring ใช้กับผลิตภัณฑ์ต่อไปนี้ที่เปิดให้เดิมพันสด:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">(A) ผู้ชนะการแข่งขัน</li>
              <li className="pt-2 pl-3">(B) ทีมที่จะผ่านเข้ารอบ</li>
            </ol>
            <li className="flex pt-2">
              <div>5.8</div>
              <div className="pl-3">การเดิมพัน e-Football</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) เว้นแต่จะระบุไว้เป็นอย่างอื่นในกฎข้อ 20.8 นี้ ให้นำกฎข้อ 20 มา
                ใช้กับการเดิมพัน e-Football
              </li>
              <li className="pt-2 pl-3">
                (B) การแข่งขัน e-Football เป็นการจำลองที่อาศัยปัญญาประดิษฐ์ การ
                เรียนรู้ของเครื่อง และฐานข้อมูลฟุตบอลในอดีต เพื่อสะท้อนฟอร์มของทีม
                และการเล่น
              </li>
              <li className="pt-2 pl-3">
                (C) แต่ละการแข่งขันจะเล่นสองครึ่ง ครึ่งละ 8 นาที รวมเวลาการแข่งขัน
                ทั้งหมด 16 นาที
              </li>
              <li className="pt-2 pl-3">
                (D) ผล สกอร์ และข้อมูลตัดสินการเดิมพันอื่น ๆ ของ e-Football จะเป็น
                ข้อมูลที่ผลิตโดยซอฟต์แวร์ และไม่สามารถหาได้จากแหล่งอื่นใด รวมถึงจาก
                เว็บไซต์ทีมหรือลีกอย่างเป็นทางการ
              </li>
              <li className="pt-2 pl-3">
                (E) การแข่งขัน e-Football เป็นการแข่งขันที่ออกอากาศ และจึงถือเป็น
                การแข่งขันแบบ Common Betting ที่ผู้ใช้ปลายทางมากกว่าหนึ่งรายสามารถ
                เดิมพันบนการแข่งขันเฉพาะ และผลของการแข่งขันนี้จะตัดสินผลลัพธ์ของการ
                เดิมพันที่วางโดยผู้ใช้ปลายทางทั้งหมด
              </li>
              <li className="pt-2 pl-3">
                (F) ในกรณีที่การแข่งขันใดไม่เสร็จสมบูรณ์ภายในเวลาที่กำหนดเนื่องจาก
                ความขัดข้องทางเทคนิคใด ๆ รวมถึงแต่ไม่จำกัดเพียงความขัดข้องของ
                คอมพิวเตอร์ อิเล็กทรอนิกส์ ซอฟต์แวร์ ฮาร์ดแวร์ หรือการเชื่อมต่อ การ
                แข่งขันจะถูกชำระผลโดยผู้ให้บริการว่าไม่สมบูรณ์ ในกรณีดังกล่าวจะมีการ
                ชำระผลเฉพาะการเดิมพันที่ได้ถูกตัดสินอย่างไม่มีเงื่อนไขเท่านั้น สำหรับ
                ตลาดอื่น ๆ ทั้งหมดและโดยไม่คำนึงถึงผลที่บ่งชี้ใด ๆ การเดิมพันจะเป็น
                โมฆะและคืนเงินเดิมพันให้ผู้ใช้ปลายทาง ผู้ให้บริการจะชำระผลการแข่งขัน
                ดังกล่าวตามกฎเหล่านี้ และการตัดสินของผู้ให้บริการถือเป็นที่สิ้นสุด
              </li>
              <li className="pt-2 pl-3">
                (G) ผู้ให้บริการขอสงวนสิทธิ์ในการประกาศให้การเดิมพัน e-Football เป็น
                โมฆะ หาก;
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) มีรายละเอียดการเดิมพันเพียงบางส่วนหรือไม่ถูกต้องเท่านั้น;
                  </li>
                  <li className="pt-2 pl-3">
                    (II) ผู้ให้บริการมีข้อสงสัยว่าผู้ใช้ปลายทางหนึ่งรายขึ้นไปกำลังมี
                    ส่วนร่วมในการฉ้อโกง การสมรู้ร่วมคิด การฟอกเงิน หรือกิจกรรมที่ผิด
                    กฎหมายอื่น ๆ;
                  </li>
                  <li className="pt-2 pl-3">
                    (III) การแข่งขันไม่ได้เริ่มต้นหรือไม่เสร็จสมบูรณ์ หรือไม่สามารถ
                    ตัดสินผลได้;
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) การยอมรับการเดิมพันจะเกินขีดจำกัดการเดิมพันใด ๆ;
                  </li>
                  <li className="pt-2 pl-3">
                    (V) จำนวนเงินเดิมพันไม่มีในบัญชีของผู้ใช้ปลายทาง;
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) ข้อผิดพลาด (จากมนุษย์หรืออื่น ๆ) หรือความล้มเหลวของระบบส่ง
                    ผลให้มีการใช้อัตราต่อรองที่ไม่ถูกต้อง;
                  </li>
                  <li className="pt-2 pl-3">
                    (VII) เกิดข้อบกพร่องทางเทคนิค เช่น ความล้มเหลวในการสื่อสาร ข้อ
                    บกพร่อง การขัดจังหวะ ความล่าช้า ไวรัส การโจมตีแบบปฏิเสธการให้
                    บริการ หรือข้อมูลเสียหาย; หรือ
                  </li>
                  <li className="pt-2 pl-3">
                    (VIII) หากข้อบกพร่องทางเทคนิคก่อให้เกิดเงินรางวัลที่มากเกินไป
                    หรือผิดปกติ
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (H) หากการเดิมพันถูกชำระผลอย่างไม่ถูกต้องเนื่องจากข้อผิดพลาด (จาก
                มนุษย์หรืออื่น ๆ) หรือความล้มเหลวของระบบ การชำระผลจะถือเป็นโมฆะและจะ
                ถูกยกเลิก หากผู้ใช้ปลายทางมีเงินในบัญชีไม่เพียงพอที่จะดำเนินการนี้
                ผู้ใช้ปลายทางจะต้องคืนเงินจำนวนที่จำเป็นให้แก่ผู้ให้บริการ
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">6. มวยไทย</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>6.1</div>
              <div className="pl-3">
                สีแดงหรือสีน้ำเงินที่กำหนดให้นักมวยมีไว้เพื่อวัตถุประสงค์ในการอ้างอิง
                เท่านั้น การเดิมพันทั้งหมดจะถือว่ามีผลโดยไม่คำนึงถึงการเปลี่ยนสีของ
                นักมวย ในเหตุการณ์ดังกล่าวจะใช้ชื่อของนักมวยในการระบุผู้ชนะของ
                เหตุการณ์
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.2</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะเป็นโมฆะหากผู้เข้าแข่งขัน ("นักมวย") คนใดคนหนึ่ง
                หรือทั้งสองคนถูกตัดสิทธิ์โดยกรรมการหรือผู้ตัดสิน ไม่ว่าจะก่อนหรือ
                ระหว่างการชก ("เหตุการณ์") การเดิมพันทั้งหมดจะเป็นโมฆะเช่นกันหากนัก
                มวยคนใดคนหนึ่งหรือทั้งสองคนถูกตัดสิทธิ์โดยกรรมการหรือผู้ตัดสินหลัง
                จากเหตุการณ์จบลงแต่ก่อนมีการประกาศการตัดสินใด ๆ
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.3</div>
              <div className="pl-3">
                เหตุการณ์จะถือว่าเริ่มต้นหรือเริ่มขึ้นเมื่อระฆังดังขึ้นสำหรับการเริ่ม
                ยกแรกเท่านั้น การเดิมพันทั้งหมดจะเป็นโมฆะหากนักมวยคนใดคนหนึ่งหรือทั้ง
                สองคนไม่สามารถเริ่มเหตุการณ์ได้
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.4</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะตัดสินจากการตัดสินอย่างเป็นทางการที่ให้ไว้บนเวที
                ทันทีหลังจากจบเหตุการณ์ การเปลี่ยนแปลงผลที่เกิดขึ้นภายหลังจะไม่ได้
                รับการยอมรับเพื่อวัตถุประสงค์ในการเดิมพัน
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.5</div>
              <div className="pl-3">
                หากมีความไม่สอดคล้องกันระหว่างชื่อนักมวยในภาษาไทยและที่ไม่ใช่ภาษา
                ไทยที่ใช้บนเว็บไซต์ ให้ถือฉบับภาษาไทยเป็นหลัก
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.6</div>
              <div className="pl-3">
                ผู้ให้บริการขอสงวนสิทธิ์ในการปฏิเสธ ไม่รับ หรือทำให้เป็นโมฆะโดยไม่
                ต้องแจ้งล่วงหน้า ต่อการเดิมพันใด ๆ ที่ผู้ให้บริการพบหรือสงสัยว่าผล
                ลัพธ์หรือการดำเนินของเหตุการณ์ใด ๆ อยู่ภายใต้การโกง การบิดเบือน หรือ
                การล้มมวย การพยายามหรือการกระทำจริงโดยผู้ใช้ปลายทางเพื่อโกง บิดเบือน
                หรือล้มมวยในเหตุการณ์ จะนำไปสู่การยุติบัญชีของพวกเขาและ/หรือการห้าม
                ถือบัญชีอย่างถาวร ตามดุลยพินิจของผู้ให้บริการ
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.7</div>
              <div className="pl-3">
                ผู้ให้บริการขอสงวนสิทธิ์ในการปฏิเสธ ไม่รับ หรือทำให้เป็นโมฆะโดยไม่
                ต้องแจ้งล่วงหน้า ต่อการเดิมพันใด ๆ ที่ผู้ให้บริการพบหรือสงสัยว่าผล
                ลัพธ์หรือการดำเนินของเหตุการณ์ใด ๆ อยู่ภายใต้การโกง การบิดเบือน หรือ
                การล้มมวย การพยายามหรือการกระทำจริงโดยผู้ใช้ปลายทางเพื่อโกง บิดเบือน
                หรือล้มมวยในเหตุการณ์ จะนำไปสู่การยุติบัญชีของพวกเขาและ/หรือการห้าม
                ถือบัญชีอย่างถาวร ตามดุลยพินิจของผู้ให้บริการ
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.8</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะมีผลในกรณีที่ชื่อของนักมวยคนใดคนหนึ่งหรือทั้งสอง
                คนถูกเปลี่ยน แต่นักมวยที่เกี่ยวข้องเป็นบุคคลเดียวกัน
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.9</div>
              <div className="pl-3">
                ในกรณีที่การเดิมพันมีข้อผิดพลาดในราคาหรืออัตราต่อรอง ต้องรายงานข้อ
                ผิดพลาดดังกล่าวต่อผู้ให้บริการภายในสิบสอง (12) ชั่วโมงนับจากการรับ
                การเดิมพัน ข้อผิดพลาดใด ๆ ที่รายงานหลังสิบสอง (12) ชั่วโมงนับจากการ
                รับการเดิมพันจะไม่ได้รับการพิจารณา
              </div>
            </li>
            <li className="flex pt-2">
              <div>6.10</div>
              <div className="pl-3">นี่คือการเดิมพันที่เปิดให้สำหรับมวยไทย:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap) — การเดิมพันอัตราต่อ
                    รองแบบเอเชียนเกี่ยวข้องกับผู้ชนะของเหตุการณ์ ในกรณีที่เหตุการณ์
                    ถูกประกาศเสมอ การเดิมพันอัตราต่อรองแบบเอเชียนทั้งหมดจะเป็นโมฆะ
                  </li>
                  <li className="pt-2 pl-3">
                    (II) สูง/ต่ำ — การเดิมพันสูง/ต่ำเกี่ยวข้องกับผลรวมของยกที่เล่นจบ
                    ในเหตุการณ์ ยกที่กำลังดำเนินอยู่ขณะที่เหตุการณ์จบลงจะไม่ถูกนับ
                    เข้าผลรวมของยก ดังนั้น หากเหตุการณ์จบ/น็อกเอาท์ในยกที่ 5 จำนวนยก
                    ที่เล่นจบคือสี่ (4) ยก หากเหตุการณ์ถูกตัดสินโดยกรรมการหลังจากยก
                    ที่ห้าจบลงโดยอ้างอิงคะแนน จำนวนยกที่เล่นจบคือห้า
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันแบบ In Running ("Live")
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap) — การเดิมพันอัตราต่อ
                    รองแบบเอเชียนเกี่ยวข้องกับผู้ชนะของเหตุการณ์ ในกรณีที่เหตุการณ์
                    ถูกประกาศเสมอ การเดิมพันอัตราต่อรองแบบเอเชียนทั้งหมดจะเป็นโมฆะ
                  </li>
                </ol>
              </li>
            </ol>
            <li className="flex pt-2">
              <div>6.11</div>
              <div className="pl-3">
                ระบบการให้คะแนนที่ใช้กับการเดิมพันสำหรับมวยไทยคือ Type B Scoring
              </div>
            </li>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. เทเบิลเทนนิส</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>7.1</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะเป็นโมฆะ หากการแข่งขันไม่เล่นจบเนื่องจากการเลิก
                เล่นหรือการตัดสิทธิ์ของผู้เล่น
              </div>
            </li>
            <li className="flex pt-2">
              <div>7.2</div>
              <div className="pl-3">
                นี่คือการเดิมพันที่เปิดให้สำหรับเทเบิลเทนนิส:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap)
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) แฮนดิแคปแต้ม</li>
                      <li className="pt-2 pl-3">(B) แฮนดิแคปเซต</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) คู่/คี่
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันคู่/คี่เกี่ยวข้องกับผลรวมของแต้มที่เล่นในการ
                        แข่งขันซึ่งได้เป็นจำนวนคู่หรือคี่
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) เอาท์ไรท์ (Outright)</li>
                  <li className="pt-2 pl-3">
                    (IV) สูง/ต่ำ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันสูง/ต่ำเกี่ยวข้องกับผลรวมของแต้มที่เล่นในการ
                        แข่งขันว่าสูงหรือต่ำกว่าจำนวนแต้มที่ผู้ให้บริการกำหนด
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันแบบ In Running ("Live")
                <ol type="I">
                  <li className="pt-2 pl-3">(I) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) ระบบการให้คะแนน
                <div className="pt-1">ใช้ Type B Scoring</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">8. เทนนิส</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>8.1</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะเป็นโมฆะหากการแข่งขันไม่เล่นจบเนื่องจากการเลิก
                เล่นหรือการตัดสิทธิ์ของผู้เล่น ยกเว้นการเดิมพันต่อไปนี้: First Ace,
                First Double Fault และการเดิมพันรายช่วง (หากการเดิมพันเหล่านี้ได้ถูก
                ตัดสินอย่างไม่มีเงื่อนไขแล้ว)
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.2</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะเป็นโมฆะหากทัวร์นาเมนต์ถูกลดความยาว เลื่อน หรือ
                ยกเลิก ยกเว้นการเดิมพันบนตลาดที่ได้ถูกตัดสินอย่างไม่มีเงื่อนไขแล้ว
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.3</div>
              <div className="pl-3">
                จำนวนเซตทั้งหมดที่ต้องใช้เพื่อชนะการแข่งขันเป็นไปตามที่ผู้จัดทัวร์
                นาเมนต์อย่างเป็นทางการกำหนด
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.4</div>
              <div className="pl-3">
                กฎ 12 ชั่วโมงไม่ใช้กับการเดิมพันเทนนิส
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.5</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดยังคงมีผลโดยไม่คำนึงถึงการเปลี่ยนสถานที่หรือพื้น
                สนาม
              </div>
            </li>
            <li className="flex pt-2">
              <div>8.6</div>
              <div className="pl-3">นี่คือการเดิมพันที่เปิดให้สำหรับเทนนิส:</div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap)
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) แฮนดิแคปแต้ม</li>
                      <li className="pt-2 pl-3">(B) แฮนดิแคปเซต</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) First Ace
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนผู้เล่นที่ทำ Ace แรกในการแข่งขันตามสถิติการ
                        แข่งขันอย่างเป็นทางการ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (III) First Double Fault
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนผู้เล่นที่ทำ double fault แรกในการแข่งขันตาม
                        สถิติการแข่งขันอย่างเป็นทางการ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IV) Aces มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนผู้เล่นที่มี Aces มากที่สุดในการแข่งขันตามสถิติ
                        การแข่งขันอย่างเป็นทางการ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) Double Fault มากที่สุด
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) เดิมพันบนผู้เล่นที่มี double faults มากที่สุดในการแข่งขัน
                        ตามสถิติการแข่งขันอย่างเป็นทางการ
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (VI) คู่/คี่
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันคู่/คี่จะตัดสินจากผลรวมของเกมที่เล่นในการ
                        แข่งขัน รวมเกมที่เพิ่มเข้ามาเมื่อการแข่งขันเป็น Tie ระหว่าง
                        การแข่งขัน (หากมี) ซึ่งได้เป็นจำนวนคู่หรือคี่
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(VII) เอาท์ไรท์ (Outright)</li>
                  <li className="pt-2 pl-3">
                    (VIII) สูง/ต่ำ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันสูง/ต่ำจะตัดสินจากผลรวมของเกมที่เล่นเมื่อจบการ
                        แข่งขัน รวมเกมที่เล่นในระหว่าง Tie (หากมี)
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (IX) การเดิมพันรายช่วง
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันทั้งหมดจะตัดสินจากจำนวนเกมรวมที่เล่นเมื่อจบเซต
                        รวมเกมที่เล่นในระหว่าง Tie
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันแบบ In Running ("Live")
                <ol type="I">
                  <li className="pt-2 pl-3">(I) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
                  <li className="pt-2 pl-3">(II) สูง/ต่ำ</li>
                  <li className="pt-2 pl-3">(III) การเดิมพันรายช่วง</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) ระบบการให้คะแนน
                <div className="pt-1">ใช้ Type B Scoring</div>
              </li>
            </ol>
          </ol>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. วอลเลย์บอล</h3>
          <ol className="pt-2">
            <li className="flex">
              <div>9.1</div>
              <div className="pl-3">
                การเดิมพันทั้งหมดจะเป็นโมฆะ หากการแข่งขันไม่เล่นจบ ยกเว้นการเดิมพัน
                รายช่วง (หากการเดิมพันได้ถูกตัดสินอย่างไม่มีเงื่อนไขแล้ว)
              </div>
            </li>
            <li className="flex pt-2">
              <div>9.2</div>
              <div className="pl-3">
                ในกรณีที่จำนวนเซตตามกฎในเกมถูกเปลี่ยนแปลง (ไม่ว่าจะก่อนหรือระหว่าง
                เกม) ผ่านการเพิ่มเซต และ/หรือ Golden Set หรือรูปแบบที่ผิดปกติอื่นใด
                (เช่น ในระหว่างการแข่งขันกระชับมิตร) เซตที่เพิ่มหรือ Golden set หรือ
                รูปแบบที่ผิดปกติดังกล่าวจะถูกละเว้น และการเดิมพันทั้งหมดจะตัดสินจาก
                ผลที่ทำได้ในระหว่างการเล่นเกมปกติเท่านั้น นี่คือการเดิมพันที่เปิดให้
                สำหรับวอลเลย์บอล:
              </div>
            </li>
            <ol type="A">
              <li className="pt-2 pl-3">
                (A) การเดิมพันที่ไม่ใช่แบบสด
                <ol type="I">
                  <li className="pt-2 pl-3">
                    (I) อัตราต่อรองแบบเอเชียน (Asian Handicap)
                    <ol type="A">
                      <li className="pt-2 pl-3">(A) แฮนดิแคปแต้ม</li>
                      <li className="pt-2 pl-3">(B) แฮนดิแคปเซต</li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (II) คู่/คี่
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันคู่/คี่เกี่ยวข้องกับผลรวมของแต้มที่เล่นในการ
                        แข่งขันซึ่งได้เป็นจำนวนคู่หรือคี่
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">(III) เอาท์ไรท์ (Outright)</li>
                  <li className="pt-2 pl-3">
                    (IV) สูง/ต่ำ
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันสูง/ต่ำเกี่ยวข้องกับผลรวมของแต้มที่เล่นในการ
                        แข่งขันว่าสูงหรือต่ำกว่าจำนวนแต้มที่ผู้ให้บริการกำหนด
                      </li>
                    </ol>
                  </li>
                  <li className="pt-2 pl-3">
                    (V) การเดิมพันรายช่วง
                    <ol type="A">
                      <li className="pt-2 pl-3">
                        (A) การเดิมพันทั้งหมดจะตัดสินจากแต้มรวมที่เล่นเมื่อจบช่วง รวม
                        แต้มทั้งหมดที่ได้ในระหว่าง deuce (ในกรณีที่เกี่ยวข้อง)
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (B) การเดิมพันแบบ In Running ("Live")
                <ol type="I">
                  <li className="pt-2 pl-3">(I) อัตราต่อรองแบบเอเชียน (Asian Handicap)</li>
                </ol>
              </li>
              <li className="pt-2 pl-3">
                (C) ระบบการให้คะแนน
                <div className="pt-1">ใช้ Type B Scoring</div>
              </li>
            </ol>
          </ol>
        </div>
      </section>

      <section>
        <div className="flex justify-center items-center pt-4">
          <h2 className="text-xl font-bold">
            D. ข้อกำหนดเกี่ยวกับบอทและระบบอัตโนมัติ
          </h2>
          <hr className="ml-3 flex-1 border-gray-300" />
        </div>

        <div className="pt-4">
          <h3 className="font-bold">1. ข้อห้ามเกี่ยวกับระบบอัตโนมัติ</h3>
          <p className="pt-2">
            ผู้ใช้งานไม่ได้รับอนุญาตให้ใช้บอท (Bots), สคริปต์ (Scripts),
            โปรแกรมอัตโนมัติ, AI Agents หรือเครื่องมือใดๆ
            ที่มีลักษณะการทำงานอัตโนมัติ เพื่อเข้าถึง ใช้งาน
            หรือดำเนินกิจกรรมบนแพลตฟอร์ม
            โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัทล่วงหน้า
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">2. ข้อห้ามเกี่ยวกับการเดิมพันอัตโนมัติ</h3>
          <p className="pt-2">
            ห้ามใช้ระบบอัตโนมัติในการส่งคำสั่งเดิมพัน กำหนดจำนวนเงินเดิมพัน
            ยืนยันการเดิมพัน ยอมรับการเปลี่ยนแปลงอัตราต่อรอง หรือดำเนินการ Cash
            Out โดยไม่มีการยืนยันจากผู้ใช้งานด้วยตนเองผ่านช่องทางที่บริษัทอนุญาต
            ทั้งนี้ รวมถึงการใช้โปรแกรมเลียนแบบการคลิก การพิมพ์
            หรือการกระทำของมนุษย์
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            3. ข้อห้ามเกี่ยวกับการดึงข้อมูลอัตโนมัติ
          </h3>
          <p className="pt-2">
            ห้ามใช้ Web Scrapers, Crawlers, Bots, Scripts
            หรือเครื่องมืออัตโนมัติอื่นใด เพื่อรวบรวม คัดลอก ตรวจสอบ
            หรือดึงข้อมูลจากแพลตฟอร์ม รวมถึงแต่ไม่จำกัดเพียง อัตราต่อรอง (Odds),
            ตลาดเดิมพัน (Betting Markets), ผลการแข่งขัน ข้อมูลบัญชี
            และประวัติธุรกรรม เว้นแต่ได้รับอนุญาตอย่างชัดแจ้งจากบริษัท
          </p>
          <p className="pt-2">
            ข้อห้ามนี้มีผลไม่ว่าการดึงข้อมูลจะเกิดขึ้นอย่างต่อเนื่อง
            เป็นครั้งคราว หรือด้วยความถี่ต่ำ
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">4. การเข้าถึง API โดยไม่ได้รับอนุญาต</h3>
          <p className="pt-2">
            ห้ามเข้าถึงหรือใช้งาน API, Endpoint, WebSocket
            หรือช่องทางรับส่งข้อมูลภายในของแพลตฟอร์มที่บริษัทไม่ได้เปิดให้ใช้งานอย่างเป็นทางการ
            การที่ Endpoint สามารถเข้าถึงได้ทางเทคนิค
            ไม่ถือเป็นการอนุญาตให้ใช้งาน
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            5. ข้อห้ามเกี่ยวกับการหลีกเลี่ยงระบบตรวจจับ
          </h3>
          <p className="pt-2">
            ห้ามใช้เทคนิคหรือเครื่องมือใดๆ
            เพื่อหลีกเลี่ยงข้อจำกัดด้านความปลอดภัย การจำกัดอัตราคำขอ (Rate
            Limits), CAPTCHA หรือระบบตรวจจับ Bot รวมถึงการใช้บัญชีหลายบัญชี
            Proxy หรือเครือข่ายอื่นเพื่อหลีกเลี่ยงข้อจำกัดดังกล่าว
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            6. การใช้ซอฟต์แวร์และบริการของบุคคลที่สาม
          </h3>
          <p className="pt-2">
            ผู้ใช้งานต้องรับผิดชอบต่อการใช้งานบัญชีของตน
            รวมถึงกิจกรรมที่เกิดจากการอนุญาตให้บุคคลที่สามหรือซอฟต์แวร์ภายนอกเข้าถึงบัญชี
            การใช้บริการภายนอกไม่ได้ยกเว้นข้อห้ามเกี่ยวกับระบบอัตโนมัติตามนโยบายนี้
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">7. เครื่องมือวิเคราะห์ที่ได้รับอนุญาต</h3>
          <p className="pt-2">
            ผู้ใช้งานสามารถใช้เครื่องมือวิเคราะห์ข้อมูล แบบจำลองทางสถิติ หรือ AI
            เพื่อช่วยประกอบการตัดสินใจเดิมพันได้
            ตราบใดที่เครื่องมือดังกล่าวไม่ได้เข้าถึงแพลตฟอร์มโดยอัตโนมัติโดยไม่ได้รับอนุญาต
            ไม่ดึงข้อมูลโดยฝ่าฝืนข้อกำหนด
            และผู้ใช้งานเป็นผู้ดำเนินการยืนยันการเดิมพันด้วยตนเอง
          </p>
          <p className="pt-2">
            เครื่องมือช่วยการเข้าถึงสำหรับผู้พิการหรือการทำงานตามปกติของเบราว์เซอร์ที่ไม่ได้ใช้เพื่อหลีกเลี่ยงข้อกำหนดนี้
            ไม่ถือเป็นระบบอัตโนมัติที่ต้องห้ามเพียงเพราะเป็นเทคโนโลยีช่วยเหลือ
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            8. ข้อยกเว้นสำหรับระบบอัตโนมัติที่ได้รับอนุญาต
          </h3>
          <p className="pt-2">
            บริษัทอาจอนุญาตให้พันธมิตรหรือผู้ใช้งานบางรายเข้าถึง API
            หรือใช้งานระบบอัตโนมัติภายใต้ข้อตกลงเป็นลายลักษณ์อักษรแยกต่างหาก
            โดยผู้ได้รับอนุญาตต้องปฏิบัติตามขอบเขตการเข้าถึง ขีดจำกัดการใช้งาน
            และเงื่อนไขทางเทคนิคที่บริษัทกำหนด
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">9. การตรวจสอบและติดตามพฤติกรรม</h3>
          <p className="pt-2">
            บริษัทสงวนสิทธิ์ในการตรวจสอบรูปแบบการใช้งาน คำขอเข้าสู่ระบบ
            กิจกรรมการเดิมพัน และข้อมูลทางเทคนิคที่เกี่ยวข้อง
            เพื่อระบุการใช้ระบบอัตโนมัติที่ไม่ได้รับอนุญาต
            โดยดำเนินการตามกฎหมายคุ้มครองข้อมูลและนโยบายความเป็นส่วนตัวที่เกี่ยวข้อง
          </p>
          <p className="pt-2">
            บริษัทอาจจำกัดการใช้งานชั่วคราวเมื่อมีเหตุอันสมควรให้สงสัยว่ามีการฝ่าฝืนนโยบาย
            ทั้งนี้
            การตรวจพบรูปแบบพฤติกรรมที่ผิดปกติเพียงอย่างเดียวไม่ได้หมายความว่ามีการพิสูจน์การกระทำผิดแล้ว
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">10. มาตรการเมื่อพบการฝ่าฝืนข้อกำหนด</h3>
          <p className="pt-2">
            หากตรวจสอบพบการฝ่าฝืนนโยบาย
            บริษัทอาจดำเนินมาตรการตามความเหมาะสมและตามที่กฎหมายอนุญาต
            ดังต่อไปนี้
          </p>
          <ul className="list-disc pl-6 pt-2 space-y-2">
            <li>จำกัดหรือปิดกั้นการเข้าถึงโดยระบบอัตโนมัติ</li>
            <li>จำกัดสิทธิ์การใช้งานหรือระงับบัญชีชั่วคราว</li>
            <li>ตรวจสอบรายการเดิมพันและธุรกรรมที่เกี่ยวข้อง</li>
            <li>
              ยกเลิกการเดิมพันที่ได้รับผลกระทบโดยตรงจากการกระทำผิด
              เมื่อได้รับอนุญาตตามกฎหมายและกฎการเดิมพันที่เกี่ยวข้อง
            </li>
            <li>
              ยุติการให้บริการหรือปิดบัญชีเมื่อยืนยันการฝ่าฝืนที่มีนัยสำคัญ
            </li>
          </ul>
          <p className="pt-2">
            การระงับบัญชีหรือการตรวจสอบไม่ถือเป็นเหตุให้ริบยอดเงินคงเหลือหรือเงินรางวัลที่ชอบด้วยกฎหมายโดยอัตโนมัติ
            ผู้ใช้งานสามารถติดต่อฝ่ายสนับสนุนเพื่อขอคำชี้แจงหรืออุทธรณ์ผลการพิจารณาได้
          </p>
        </div>

        <div className="pt-4">
          <h3 className="font-bold">
            11. การตีความข้อกำหนดและกฎหมายที่เกี่ยวข้อง
          </h3>
          <p className="pt-2">
            นโยบายนี้เป็นส่วนหนึ่งของข้อกำหนดและเงื่อนไขการใช้บริการของบริษัท
            และต้องตีความร่วมกับกฎการเดิมพัน นโยบายความเป็นส่วนตัว
            และกฎหมายที่เกี่ยวข้อง
            ในกรณีที่ข้อความใดขัดต่อกฎหมายหรือข้อกำหนดของหน่วยงานกำกับดูแล
            ให้ใช้กฎหมายหรือข้อกำหนดดังกล่าวเป็นหลัก
          </p>
        </div>
      </section>
    </div>
  );
};

export default RulesContentTH;
